/**
 * ftk-v18.js — Farbtonfinder V18 UI
 * Anbindung: window.FTK (farbtonkonfigurator-data-bridge.js)
 * Warenkorb:  window.FTKATC (ftk-atc-v17.js)
 * Export: window.FTKV18 = { boot(rootEl, config) }
 */
/* global FTK, FTKATC, FTK_MANIFEST, FTK_ASSET_BASE */
(function (global) {
  "use strict";

  // ============================================================
  // KONSTANTEN
  // ============================================================
  var FAV_KEY        = "fb_favoriten";
  var GRIDSIZE_KEY   = "ftk18_gridsize";
  var GRID_PAGE_SIZE = 120;
  var GRID_PAGE_MORE = 80;
  var SEARCH_DEBOUNCE = 240;
  var ERGIEBIGKEIT   = 7; // m²/L pro Anstrich
  // Bewertungszahl kommt aus Shop-Metafeld farbenbote.trust_bewertungen,
  // von der Section als data-trust-reviews an #ftk-v18-root gereicht.
  var TRUST_REVIEWS  = (function () {
    var el = document.getElementById("ftk-v18-root");
    return (el && el.getAttribute("data-trust-reviews")) || "14.862";
  })();

  var FAMILY_LIST = [
    { id: "alle",  label: "Alle",             swatch: null },
    { id: "weiss", label: "Weiß & Creme",     swatch: "#F5F0E8" },
    { id: "beige", label: "Beige & Sand",      swatch: "#D4C09B" },
    { id: "grau",  label: "Grau & Greige",     swatch: "#9CA3AF" },
    { id: "gruen", label: "Grün",              swatch: "#6B9B6F" },
    { id: "blau",  label: "Blau & Petrol",     swatch: "#3B82F6" },
    { id: "gelb",  label: "Gelb & Ocker",      swatch: "#D97706" },
    { id: "rot",   label: "Rot & Terracotta",  swatch: "#C0614A" },
    { id: "rose",  label: "Rosé & Violett",    swatch: "#C084FC" }
  ];

  // Mood-Daten (Stimmungen) — Palettenfarben sind HSL-Annäherungen,
  // werden per nearestColor() auf echte Töne gemappt
  var MOODS = [
    { id: "skandinavisch",  label: "Skandinavisch",    desc: "Ruhig, hell und einladend",    palette: ["#F0EBE0","#D6CDB8","#B8B0A0","#9EA09A","#748490"] },
    { id: "erdtoene",       label: "Erdtöne",          desc: "Warm, natürlich und geerdet",  palette: ["#C4935A","#A67842","#8B6038","#6E4A2A","#4D3218"] },
    { id: "salbei",         label: "Salbei & Grün",    desc: "Frisch und naturnah",          palette: ["#D8E8D0","#B8D0A8","#8FB070","#6A9048","#4A7030"] },
    { id: "warm-neutral",   label: "Warme Neutrale",   desc: "Zeitlos, behaglich",           palette: ["#F0E8D8","#E0CEB0","#C8B090","#A89070","#8A7058"] },
    { id: "dramatisch",     label: "Tief & Dramatisch",desc: "Mutig, ausdrucksstark",        palette: ["#2A2A3A","#3A3050","#4A2040","#5A1030","#1A2040"] },
    { id: "maritim",        label: "Maritim",          desc: "Frisch, klar, küstennah",      palette: ["#E8F4F8","#B0D8E8","#70B0D0","#3080A8","#105080"] },
    { id: "sonnig",         label: "Sonnig & Frisch",  desc: "Hell, heiter, lebendig",       palette: ["#FFF8E0","#FFE880","#FFD040","#E8B820","#C89000"] }
  ];

  var AREA_PILLS = [
    { id: "innen",   label: "Innen" },
    { id: "fassade", label: "Fassade" },
    { id: "lack",    label: "Lack" }
  ];

  // Mapping Bereich → Szene-ID für FTK.getCompatibleProducts
  var AREA_TO_FTK_SCENE = {
    innen:   "wohnzimmer",
    fassade: "fassade",
    lack:    "holz"
  };


  // Produktauswahl je Bereich (Owner): genau 3 bevorzugte Produkte, sonst Auffüllen
  // aus derselben Kategorie. Szene bestimmt, welche Kategorien geliefert werden;
  // wir filtern zusätzlich auf die gewünschten Kategorien.
  // Szene steuert in der Bridge nur die Kategorie-Begrenzung (QA-Scope), NICHT
  // die Machbarkeit (isColorCompatible ist szenen-unabhängig). Innen/Fassade nutzen
  // valide Szenen (→ Innen-/Fassadenfarben). Lack braucht Lacke UND Lasuren, was
  // keine einzelne valide Szene liefert ("metall"→Lacke, "holz"→Lasuren) → bewusst
  // eine unbekannte Szene ("lack-all") → Bridge gibt ALLE Kategorien zurück, wir
  // filtern danach selbst auf AREA_PRODUCT_CATS.lack.
  var AREA_PRODUCT_SCENE = { innen: "wohnzimmer", fassade: "fassade", lack: "lack-all" };
  var AREA_PRODUCT_CATS  = { innen: ["Innenfarben"], fassade: ["Fassadenfarben"], lack: ["Lacke","Lasuren"] };
  var PREFERRED_PRODUCTS = {
    innen:   ["StoColor In", "StoColor Sil In", "StoColor Rapid Ultramatt"],
    fassade: ["Lotusan", "StoColor Silco", "StoColor Jumbosil"],
    lack:    ["StoAqua Top Satin", "StoAqua Emaille PU Satin", "StoCorr Metalllack"]
  };

  var GEBINDE_SIZES = [2.5, 5, 10, 15];

  // Herz als Inline-SVG (NICHT das Zeichen ♥/U+2665 — iOS rendert das als rotes
  // Emoji und ignoriert die CSS-Farbe → mobil erschienen alle Töne "gemerkt").
  // Umriss = nicht gemerkt, gefüllt rot = gemerkt (Steuerung per CSS-Klasse).
  var HEART_SVG = '<svg class="ftk-v18__heart-svg" viewBox="0 0 24 24" width="15" height="15" aria-hidden="true"><path d="M12 20.3l-1.45-1.32C5.4 14.24 2 11.15 2 7.4 2 4.42 4.42 2 7.4 2c1.74 0 3.41.81 4.6 2.09C13.19 2.81 14.86 2 16.6 2 19.58 2 22 4.42 22 7.4c0 3.75-3.4 6.84-8.55 11.58L12 20.3z"/></svg>';
  // „Vergrößern"-Icon (diagonale Pfeile) — gleiche Optik wie im Visualizer.
  var ENLARGE_SVG = '<svg viewBox="0 0 24 24" width="15" height="15" aria-hidden="true" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M15 3h6v6M9 21H3v-6M21 3l-7 7M3 21l7-7"/></svg>';

  // P4: PC-Preisstufen-Labels (Klartext) — module-level Konstante.
  var PC_LABELS = { "01":"PC 1 · kein Aufpreis", "02":"PC 2 · gering", "03":"PC 3 · mittel", "04":"PC 4 · höchster" };

  // Fehler 1: Top-Karten als Direktauswahl-Pills neben dem Karten-Dropdown.
  // Slug→Label kommt aus dem Manifest; fehlende Slugs werden übersprungen.
  var TOP_CARDS = [
    "stocolor-system-2022", "stocolor-system", "ral-farbtonkarte", "ral-design",
    "ncs-system-edition-2", "schoener-wohnen-farbe", "caparol-3d-system", "sikkens-akzo-nobel"
  ];

  // Bereich (Step 2) → Default-Start-Szene des FTKVisualizer-Moduls.
  // Slugs müssen den internen Szenen des Visualizers entsprechen:
  // 'wohnzimmer' | 'schlafzimmer-1' | 'fassade' | 'kinderzimmer'.
  // Im Modul wählt der Nutzer die Szene anschließend selbst aus der Galerie.
  function areaToVizScene(area) {
    if (area === "fassade") return "fassade";
    return "wohnzimmer"; // innen/lack → neutral
  }

  // ============================================================
  // UTIL
  // ============================================================
  function esc(s) {
    return String(s || "")
      .replace(/&/g,"&amp;").replace(/</g,"&lt;").replace(/>/g,"&gt;")
      .replace(/"/g,"&quot;").replace(/'/g,"&#39;");
  }

  function norm(s) {
    return String(s || "")
      .toLowerCase()
      .replace(/ä/g,"ae").replace(/ö/g,"oe").replace(/ü/g,"ue").replace(/ß/g,"ss")
      .normalize("NFKD").replace(/[̀-ͯ]/g,"");
  }

  function isValidHex(h) { return /^#?[0-9a-fA-F]{6}$/.test(String(h||"")); }

  function hexToRgb(hex) {
    var c = String(hex||"").replace("#","");
    if (!/^[0-9a-fA-F]{6}$/.test(c)) return {r:128,g:128,b:128};
    var n = parseInt(c, 16);
    return { r:(n>>16)&255, g:(n>>8)&255, b:n&255 };
  }

  function rgbToHsl(r,g,b) {
    r/=255; g/=255; b/=255;
    var max=Math.max(r,g,b), min=Math.min(r,g,b);
    var h=0, s=0, l=(max+min)/2;
    if (max!==min) {
      var d=max-min;
      s = l>0.5 ? d/(2-max-min) : d/(max+min);
      if (max===r) h=(g-b)/d+(g<b?6:0);
      else if (max===g) h=(b-r)/d+2;
      else h=(r-g)/d+4;
      h*=60;
    }
    return {h:h,s:s,l:l};
  }

  function hslToHex(h,s,l) {
    s/=100; l/=100;
    var k=function(n){ return (n+h/30)%12; };
    var a=s*Math.min(l,1-l);
    var f=function(n) {
      var x=l-a*Math.max(-1,Math.min(k(n)-3,Math.min(9-k(n),1)));
      return Math.round(255*x).toString(16).padStart(2,"0");
    };
    return ("#"+f(0)+f(8)+f(4)).toUpperCase();
  }

  function hexLuminance(hex) {
    var rgb = hexToRgb(hex);
    return (0.2126*rgb.r + 0.7152*rgb.g + 0.0722*rgb.b) / 255;
  }

  function isLightHex(hex) {
    var rgb = hexToRgb(hex);
    return (rgb.r*299+rgb.g*587+rgb.b*114)/1000 > 145;
  }

  function colorFamilyId(color) {
    // Nutze tonePrimary aus der Bridge, mappe auf FAMILY_LIST-IDs
    var p = color.tonePrimary || "";
    if (p==="weiss"||p==="creme") return "weiss";
    if (p==="beige"||p==="sand"||p==="taupe") return "beige";
    if (p==="grau"||p==="anthrazit"||p==="schwarz") return "grau";
    if (p==="gruen"||p==="mint"||p==="oliv"||p==="petrol"||p==="tuerkis"||p==="cyan") return "gruen";
    if (p==="blau"||p==="marineblau"||p==="indigo") return "blau";
    if (p==="gelb"||p==="ocker") return "gelb";
    if (p==="rot"||p==="weinrot"||p==="terrakotta"||p==="koralle"||p==="orange"||p==="lachs") return "rot";
    if (p==="violett"||p==="lavendel"||p==="magenta"||p==="rosa") return "rose";
    // Fallback ohne tonePrimary (z. B. kartenübergreifende Worker-Treffer):
    // Familie aus dem Hex via HSL ableiten, statt pauschal "grau".
    return familyFromHex(color.hex);
  }

  // HSL-basierte Familien-Heuristik (Fallback für Treffer ohne tonePrimary)
  function familyFromHex(hex) {
    var rgb = hexToRgb(hex||"#888888");
    var hsl = rgbToHsl(rgb.r, rgb.g, rgb.b);
    var h = hsl.h, s = hsl.s, l = hsl.l;   // h bereits in Grad (rgbToHsl: h*=60)
    if (l>=0.90 && s<0.18) return "weiss";
    if (s<0.12) return "grau";                          // echtes Neutralgrau
    if (s<0.30 && l>=0.55 && (h>=20 && h<70)) return "beige"; // entsättigtes Warm = Sand/Beige
    if (h<15 || h>=345) return "rot";
    if (h<45) return (l>=0.5 && s<0.45) ? "beige" : "rot";    // Orange→Terracotta/Sand
    if (h<70) return "gelb";
    if (h<170) return "gruen";
    if (h<255) return "blau";                            // inkl. Petrol/Cyan-Blau
    if (h<290) return "blau";
    return "rose";                                       // Violett/Magenta/Rosa
  }

  function rgbDist(hexA, hexB) {
    var a=hexToRgb(hexA), b=hexToRgb(hexB);
    return Math.sqrt((a.r-b.r)**2+(a.g-b.g)**2+(a.b-b.b)**2);
  }

  function nearestColor(hex, colors) {
    if (!colors||!colors.length) return null;
    var t = hexToRgb(hex);
    var best=null, bd=Infinity;
    for (var i=0;i<colors.length;i++) {
      var c = colors[i];
      // RGB einmalig am Ton cachen — nearestColor läuft beim Farbkreis-Drag
      // pro pointermove über ALLE Töne (Sikkens: 8.442); Regex+parseInt je
      // Aufruf waren auf Mobile spürbar (Review-Befund 2026-07-09).
      if (c._rgb === undefined) {
        // Töne ohne gültigen hex überspringen: hexToRgb liefert sonst Grau
        // (#808080), wodurch ein solcher Ton bei hellen Wheel-Positionen
        // fälschlich als „nächster" gewinnt → graue Vorschau + tote Szene.
        c._rgb = isValidHex(c.hex) ? hexToRgb(c.hex) : null;
      }
      if (!c._rgb) continue;
      var dr=t.r-c._rgb.r, dg=t.g-c._rgb.g, db=t.b-c._rgb.b;
      var d=dr*dr+dg*dg+db*db; // Quadrat reicht für den Vergleich (kein sqrt)
      if (d<bd){bd=d;best=c;}
    }
    return best;
  }

  function getHarmonics(color, colors) {
    if (!colors||!colors.length) return [];
    // rgbToHsl liefert h bereits in Grad (0..360) — NICHT noch einmal *360.
    var rgb=hexToRgb(color.hex), hsl=rgbToHsl(rgb.r,rgb.g,rgb.b);
    // 6 Rollen (Owner: mehr Töne + Kontrast). "Kontrast" = Komplementärton mit
    // bewusst großem Hell-Dunkel-Abstand; "Triade" = +120° für ein drittes Schema.
    var targets = [
      { role:"komplementär", targetH:(hsl.h+180)%360 },
      { role:"Kontrast",     targetH:(hsl.h+180)%360, contrastL:true },
      { role:"analog ➕",    targetH:(hsl.h+30)%360  },
      { role:"analog ➖",    targetH:(hsl.h-30+360)%360 },
      { role:"Triade",       targetH:(hsl.h+120)%360 },
      { role:"neutral",      targetH:hsl.h, lDelta:0.2 }
    ];
    var used = {}; used[color.id] = true;   // jede Rolle einen ANDEREN Ton
    return targets.map(function(t) {
      var best=null, bd=Infinity;
      for (var i=0;i<colors.length;i++) {
        var cc=colors[i];
        if (used[cc.id]) continue;
        var ch=hexToRgb(cc.hex), chsl=rgbToHsl(ch.r,ch.g,ch.b);
        var dh=Math.min(Math.abs(chsl.h-t.targetH),360-Math.abs(chsl.h-t.targetH))/180;
        var dl;
        if (t.contrastL)            dl = 1 - Math.abs(chsl.l-hsl.l);   // großen Hell-Dunkel-Abstand bevorzugen
        else if (t.lDelta!==undefined) dl = Math.abs(Math.abs(chsl.l-hsl.l)-t.lDelta);
        else                        dl = Math.abs(chsl.l-hsl.l)*0.3;
        var d=dh+dl;
        if (d<bd){bd=d;best=cc;}
      }
      if (best) { used[best.id]=true; return {c:best,role:t.role}; }
      return null;
    }).filter(Boolean);
  }

  function fmtEur(n) {
    return new Intl.NumberFormat("de-DE",{style:"currency",currency:"EUR"}).format(n);
  }

  // Anzeige-Cleanup für Codes in Namen aus dem globalen Worker-Index
  // ("Ral5010 Enzianblau" → "RAL 5010 Enzianblau"). Nur kosmetisch — die
  // echte ID (c.id) bleibt für MABA/Lookup unangetastet.
  function prettyName(name) {
    return String(name||"")
      .replace(/\bRal\s*(\d)/i, "RAL $1")
      .replace(/\bNcs\b/i, "NCS")
      .replace(/\bRAL\s*(\d{4})\b/, "RAL $1");
  }

  // Beschreibender Teil des Namens für die Kachel: führenden Code aus dem
  // Namen abtragen, wenn er die ID dupliziert ("RAL 3020 Verkehrsrot" + id
  // "RAL3020" → "Verkehrsrot"; "B41 27 31 Ultramarin" + "B412731" → "Ultramarin").
  function tileLabel(c) {
    var name = prettyName(c && c.name);
    var id = String(c && c.id || "").replace(/\s/g, "").toLowerCase();
    if (!id || !name) return name;
    var parts = name.split(/\s+/), acc = "", cut = 0;
    for (var i = 0; i < parts.length; i++) {
      acc += parts[i].toLowerCase();
      if (id === acc) { cut = i + 1; break; }
      if (id.indexOf(acc) !== 0) break;   // nicht länger Präfix der ID
    }
    return cut > 0 ? parts.slice(cut).join(" ") : name;
  }

  // ============================================================
  // BOOT
  // ============================================================
  function boot(rootEl, config) {
    if (!rootEl) { console.error("[FTKV18] rootEl fehlt."); return; }
    if (!global.FTK)  { console.error("[FTKV18] window.FTK fehlt."); return; }

    config = config || {};
    var assetBase    = config.assetBase    || global.FTK_ASSET_BASE || "";
    var musterUrl    = config.musterUrl    || "";
    var defaultCard  = config.defaultCard  || "stocolor-system-2022";
    // Angeheftete Karten (z.B. Lasuren auf Lasur-PDPs): erscheinen als erste Pills
    // im Karten-Umschalter, auch wenn sie NICHT im Manifest stehen → jederzeit zurück.
    var pinnedCards  = (config.pinnedCards && config.pinnedCards.length) ? config.pinnedCards : [];
    var visualizerUrl = config.visualizerUrl || "";
    var manifest     = global.FTK_MANIFEST || {};
    var manifestCards = (manifest.cards || []);

    // ── PDP-Modus: Finder läuft als Modal AUF einer Produktseite ──
    // Dann: nur DIESES Produkt (kein Produkt-Picker), nur Farbtöne die in ihm
    // tönbar sind, und der Commit übernimmt den Ton auf der PDP (config.onApply)
    // statt zu einer anderen Produktseite zu navigieren.
    var pdpMode    = config.mode === "pdp";
    var pdpProduct = config.product || null;            // {sku,handle,title,variants,verbrauch}
    var pdpSku     = pdpProduct && pdpProduct.sku ? String(pdpProduct.sku) : "";
    // MABA-Tönbarkeit hängt an der GETÖNT/PC-Variante, NICHT an der Weiß-Variante.
    // Der Boot bekommt aber oft die Weiß-Variante (selected_or_first_available) —
    // deren MABA-Gruppe ist weniger restriktiv. Folge: das Grid zeigte Töne, die
    // der PDP-Gate beim Übernehmen sperrt ("✓ tönbar" → danach "nicht tönbar").
    // Darum hier die tönbare Base aus den Varianten ableiten, EXAKT wie der Gate
    // (variants.find auf die erste getönt/PC-Variante, Größen-Suffix /1..4 weg).
    if (pdpMode && pdpProduct && pdpProduct.variants && pdpProduct.variants.length) {
      for (var _vi = 0; _vi < pdpProduct.variants.length; _vi++) {
        var _v = pdpProduct.variants[_vi];
        var _o1 = (_v && (_v.option1 != null ? _v.option1 : _v.o1) || "").toString().toLowerCase();
        if (/get(ö|oe)nt|pc\s*\d/.test(_o1) && _v.sku) {
          pdpSku = String(_v.sku).replace(/\/[1-4]$/, "");
          break;
        }
      }
    }
    // PDP-Modus: Karten ohne Tönbarkeitsdaten (manifest "maba": false) komplett
    // ausblenden — das Sperrlisten-Modell ist fail-open, ohne Daten erschiene
    // dort ALLES fälschlich als "✓ tönbar" (Review-Befund: 23 Karten/4.826 Töne).
    var mabaCoveredCards = null;
    if (pdpMode) {
      manifestCards = manifestCards.filter(function(c){ return c && c.maba !== false; });
      mabaCoveredCards = {};
      manifestCards.forEach(function(c){
        if (c.slug)  mabaCoveredCards[c.slug]  = true;
        if (c.label) mabaCoveredCards[c.label] = true;
      });
      // Angeheftete/Default-Karten (z.B. Lasuren) sind kuratiert → immer erlaubt.
      pinnedCards.forEach(function(p){
        if (p && p.slug)  mabaCoveredCards[p.slug]  = true;
        if (p && p.label) mabaCoveredCards[p.label] = true;
      });
      if (defaultCard) mabaCoveredCards[defaultCard] = true;
    }
    var onApply    = typeof config.onApply === "function" ? config.onApply : null;
    // Deep-Link von einer Farbtonkarte: nach dem Laden der Default-Karte direkt
    // das Detail-Modal dieses Tons öffnen (config.openTon = Farbton-ID/Code).
    var pendingOpenTon = (config.openTon || "").toString();
    // Übergebene Suchanfrage (?q= aus der Shop-Suche) — wird nach dem Boot angewandt.
    var initialQuery = (config.initialQuery || "").toString();
    // Request-Token für loadCard — MUSS vor dem ersten loadCard-Aufruf im
    // Boot-Fluss initialisiert sein (Hoisting-Falle: stand die Zuweisung weiter
    // unten, war loadSeq beim Boot undefined → myId=NaN → Boot-Response wurde
    // als "veraltet" verworfen → leeres Grid. Live-debuggt 2026-07-09).
    var loadSeq = 0;
    function _tonKey(s){ return String(s||"").replace(/[^0-9A-Za-z]/g,"").toUpperCase(); }
    // Fertig-Weiß-Töne (Regel 2026-07-09): NUR diese 5 laufen über die
    // weiß-Variante zum Weiß-Preis — Sto liefert sie ohne Tönaufschlag, das
    // ERP setzt bei der Übermittlung die getönt-Artikelnummer ein. ALLE
    // anderen Klasse-0-Weißtöne (RAL9003, 16002, 16000, STH02, Y-Codes …)
    // sind normale PC1-Töne (getönt-Artikel + PC1-Preis).
    var FERTIG_WEISS_IDS = { AW11:1, AW15:1, RAL9010:1, RAL9016:1, NS01213:1 };
    function isFertigWeiss(id){ return FERTIG_WEISS_IDS[_tonKey(id)] === 1; }

    // ── Tracking (Schema von V17 übernommen, ui_version:"v18") ──
    function trackFTK(event, params) {
      try {
        var p = Object.assign({ ui_version: "v18" }, params || {});
        if (global.gtag) { global.gtag("event", event, p); return; }
        global.dataLayer = global.dataLayer || [];
        global.dataLayer.push(Object.assign({ event: event }, p));
      } catch(e) { /* silent */ }
    }

    // ── State ──
    var S = {
      // PDP-Modus (siehe oben): nur dieses Produkt + nur tönbare Töne
      pdpMode: pdpMode,
      pdpSku: pdpSku,
      mabaReady: false,   // im PDP-Modus: erst true, wenn MABA-Daten geladen
      rawColors: [],      // ungefilterte Karte (PDP-Filter wird darauf neu angewandt)

      // Einstieg — Visualtool rechts (Suche ist dauerhaft links sichtbar)
      entry: "farbkreis",
      query: "",
      cardDropdownOpen: false,

      // Filter
      family: "alle",
      helFilter: null, // null | "hell" | "mittel" | "dunkel" (von "Geführt")
      brightness: 50,        // P4: Helligkeits-Slider 0..100
      brightnessActive: false,
      pcFilter: { "01": true, "02": true, "03": true, "04": true }, // P4: Preisstufen
      gridSize: "normal",    // P4: mini | normal | large (localStorage ftk18_gridsize)

      // Farben
      colors: [],
      displayedCount: GRID_PAGE_SIZE,

      // Globale Suche (kartenübergreifend, wie V17 Fix 3)
      globalMode: false,        // true sobald Worker-Treffer da sind
      globalResults: [],        // gemappte Treffer aus allen Karten
      globalAbort: null,        // AbortController der laufenden Suche

      // Farbrad
      wheelH: 150, wheelS: 42, wheelL: 60,
      wheelDrag: false,

      // Geführt
      gRaum: null, gStimmung: null, gHell: null,

      // Detail modal
      sel: null,
      area: "innen",
      prodIdx: 0,
      gebindeLabel: null,
      calcArea: 30,
      calcCoats: 2,
      vizMode: "farbe",        // "farbe" | "raum" | "foto" — wie V17 (seg-toggle)

      // Visualizer (echtes FTKVisualizer-Modul, lazy)
      visualizerLoaded: false,
      visualizerLoading: false,
      visualizerController: null,

      // Produkte (aus FTK.getCompatibleProducts)
      products: [],        // angezeigte Liste (kuratierte 3 oder Suchergebnis)
      productPool: [],     // alle machbaren Produkte des Bereichs (für die Suche)
      prodQuery: "",       // Produkt-Suchbegriff im Modal
      productsLoaded: false, // true sobald loadProducts gelaufen ist (Leertext-Logik)

      // Merkliste
      favs: [],
      favOpen: false,

      // Karte
      currentSlug: defaultCard,
      loading: false
    };

    // Favoriten aus localStorage
    try {
      var stored = JSON.parse(localStorage.getItem(FAV_KEY)||"[]");
      if (Array.isArray(stored)) S.favs = stored;
    } catch(e) {}

    // P4: Kachelgröße aus localStorage (Default normal)
    try {
      var gs = localStorage.getItem(GRIDSIZE_KEY);
      if (gs && ["mini","normal","large"].indexOf(gs)>=0) S.gridSize = gs;
    } catch(e) {}

    function saveFavs() {
      try { localStorage.setItem(FAV_KEY, JSON.stringify(S.favs)); } catch(e) {}
    }
    function isFav(id) { return S.favs.some(function(f){return f.id===id;}); }
    function toggleFav(color) {
      var idx=S.favs.findIndex(function(f){return f.id===color.id;});
      if (idx>=0) S.favs.splice(idx,1);
      // cs = Karten-SLUG des Tons: bei globalen Suchtreffern steckt der im
      // color.card (Worker liefert Slugs) — S.currentSlug wäre die falsche,
      // gerade aktive Karte (Review-Befund: Cross-Card-Favorit → PC1-Preis).
      else S.favs.push({id:color.id,n:color.name,h:color.hex,cs:((color._global&&color.card)?color.card:S.currentSlug),card:color.card});
      saveFavs();
    }

    // ── Boot-Closure-Konstanten (müssen VOR dem ersten buildRootHtml()-Aufruf stehen) ──
    // Visualtool-Umschalter rechts (Suche ist dauerhaft links, kein Tab mehr).
    var TOOL_TABS = [
      { id:"farbkreis", label:"Farbkreis" },
      { id:"stimmungen",label:"Stimmung"  },
      { id:"gefuehrt",  label:"Geführt"   }
    ];

    // ── DOM root ──
    rootEl.classList.add("ftk-v18");

    function q(sel)  { return rootEl.querySelector(sel); }
    function qa(sel) { return rootEl.querySelectorAll(sel); }

    // ── Build initial HTML ──
    rootEl.innerHTML = buildRootHtml();
    attachEvents();
    setupStickyOffset();
    setupMobSearch();
    setupWheelVizObserver();
    setupTrustBadgeHide();

    // PDP-Modus: MABA sofort laden → danach Grid/Wheel/Harmonien auf die im
    // PDP-Produkt tönbaren Töne filtern. Schlägt das Laden fehl, wird nicht
    // blockiert (graceful: leere Sperrliste = alles tönbar).
    if (pdpMode && pdpSku && global.FTK.triggerMabaLoad) {
      var finalizeMaba = function(){
        if (S.mabaReady) return;          // nur einmal
        S.mabaReady = true;
        S.colors = pdpFilter(S.rawColors.length ? S.rawColors : S.colors);
        renderGrid();
        if (q('[data-v18-panel="farbkreis"]')) rerenderWheelNearest();
      };
      // Timeout-Sicherung: hängt MABA, bleibt das Grid nicht ewig im Skeleton —
      // nach 6 s graceful weiter (leere Sperrliste ⇒ isColorCompatible = alle tönbar).
      var mabaTO = setTimeout(function(){
        if (!S.mabaReady) { try { console.warn("[FTKV18] MABA-Timeout — zeige alle Töne (graceful)."); } catch(e){} finalizeMaba(); }
      }, 6000);
      global.FTK.triggerMabaLoad({ skuOnly: true })
        .then(function(){
          clearTimeout(mabaTO);
          if (S.mabaReady) {
            // Timeout hatte schon (ungefiltert) freigegeben — jetzt, wo die
            // Daten da sind, einmal echt nachfiltern (Review-Befund 2026-07-09).
            S.colors = pdpFilter(S.rawColors.length ? S.rawColors : S.colors);
            S.displayedCount = GRID_PAGE_SIZE;
            renderGrid();
            if (q('[data-v18-panel="farbkreis"]')) rerenderWheelNearest();
          } else {
            finalizeMaba();
          }
        })
        .catch(function(){ clearTimeout(mabaTO); try { console.warn("[FTKV18] MABA-Load fehlgeschlagen — zeige alle Töne (graceful)."); } catch(e){} finalizeMaba(); });
    }

    // ESC bei offenem Karten-Dropdown: NUR das Dropdown schließen (capture,
    // damit der PDP-Wrapper-Listener nicht zuerst das ganze Modal schließt).
    document.addEventListener("keydown", function(e){
      if (e.key !== "Escape" || !S.cardDropdownOpen) return;
      e.stopPropagation();
      closeCardDropdown();
    }, true);

    trackFTK("ftk_finder_open", { mode: pdpMode ? "pdp" : "standalone" });

    // ── Load default card ──
    loadCard(defaultCard);

    // Suchanfrage aus der Shop-Suche (?q=) direkt anwenden
    if (initialQuery) {
      S.query = initialQuery;
      qa('[data-v18="search-input"]').forEach(function(inp){ inp.value = initialQuery; });
      qa('[data-v18="search-clear"]').forEach(function(c){ c.style.display = ""; });
      try { triggerGlobalSearch(initialQuery); } catch(e){}
    }

    // ============================================================
    // HTML BUILDERS
    // ============================================================
    function buildRootHtml() {
      // Kein Header/Hero/Sticky-Bar (Owner-Wunsch) — direkt das Vollbreiten-Layout:
      // links 50% Such-/Karten-Kasten + Visualtool, rechts 50% Farbtöne + Filter.
      return buildMobSearch() +
             '<div class="ftk-v18__main2">' +
               '<div class="ftk-v18__pane-left">' +
                 buildSearchPanel() +
                 '<div class="ftk-v18__tool-col">' +
                   buildToolSwitch() +
                   buildWheelPanel() +
                   buildMoodsPanel() +
                   buildGuidedPanel() +
                 '</div>' +
               '</div>' +
               '<div class="ftk-v18__pane-right">' +
                 buildResultsSection() +
               '</div>' +
             '</div>' +
             (pdpMode ? '' : buildTrustStrip()) +
             '<div class="ftk-v18__modal-slot"></div>' +
             '<div class="ftk-v18__fav-slot"></div>' +
             '<div class="ftk-v18__lightbox-slot"></div>' +
             '<div class="ftk-v18__toast-slot" aria-live="polite"></div>';
    }

    // Mobile: schlanke, einzeilige Suchleiste, die beim Scrollen oben fixiert wird
    // (erscheint, sobald das Hauptsuchfeld nach oben rausscrollt). Nur auf Mobile
    // sichtbar (CSS). Gleiches data-v18="search-input" → synchron + globale Suche.
    function buildMobSearch() {
      return '<div class="ftk-v18__mobsearch" data-v18="mobsearch">' +
        '<div class="ftk-v18__mobsearch-inner">' +
          '<span class="ftk-v18__search-icon">&#128269;</span>' +
          '<input type="search" class="ftk-v18__mobsearch-input" data-v18="search-input" ' +
            'aria-label="Farbton oder Code suchen" placeholder="RAL 7016, NCS oder „Salbei“" ' +
            'autocomplete="off" spellcheck="false" value="'+esc(S.query)+'">' +
          '<button class="ftk-v18__search-clear" data-v18="search-clear" style="display:'+(S.query?"":"none")+'">&times;</button>' +
        '</div>' +
      '</div>';
    }

    // 3-fach-Umschalter über dem Visualtool. data-v18="tab" → bestehender
    // handleClick-case "tab" ruft setEntry() unverändert.
    function buildToolSwitch() {
      // Segmented-Control aus nativen <button> → per Tab fokussierbar, Enter/Space
      // aktiviert. aria-pressed (Toggle-Semantik) statt halbem tablist-Pattern.
      var html = '<div class="ftk-v18__tool-switch" role="group" aria-label="Visuelles Werkzeug wählen">';
      TOOL_TABS.forEach(function(t) {
        var act = S.entry===t.id;
        html += '<button type="button" class="ftk-v18__tool-seg'+(act?" ftk-v18__tool-seg--active":"")+'" data-v18="tab" data-tab="'+esc(t.id)+'" aria-pressed="'+(act?"true":"false")+'">' +
          '<span class="ftk-v18__tool-seg-lbl">'+esc(t.label)+'</span>' +
        '</button>';
      });
      html += '</div>';
      return html;
    }

    function buildSearchPanel() {
      // Suche ist dauerhaft sichtbar (kein Panel-Toggle) — .ftk-v18__search-pinned
      // statt .ftk-v18__panel + KEIN data-v18-panel, damit setEntry sie nie versteckt.
      return '<div class="ftk-v18__search-pinned">' +
        '<div class="ftk-v18__search-card">' +
          '<div class="ftk-v18__search-input-wrap">' +
            '<span class="ftk-v18__search-icon">&#128269;</span>' +
            '<input type="search" class="ftk-v18__search-input" data-v18="search-input" ' +
              'aria-label="Farbton oder Code suchen" ' +
              'placeholder="z. B. RAL 7016, NCS S 2010-Y30R oder „Salbei“" ' +
              'autocomplete="off" spellcheck="false" value="'+esc(S.query)+'">' +
            '<button class="ftk-v18__search-clear" data-v18="search-clear" style="display:'+(S.query?"":"none")+'">&times;</button>' +
          '</div>' +
          buildCardChooser() +
        '</div>' +
      '</div>';
    }

    // Fehler 1: EINE Kollektions-Komponente unter dem Suchfeld —
    // durchsuchbares Dropdown „Farbtonkarte wählen" (alle Karten) + Top-8-Pills.
    function buildCardChooser() {
      var cur = manifestCards.find(function(c){ return c.slug===S.currentSlug; });
      var curLabel = cur ? (cur.label||cur.slug) : "Farbtonkarte wählen";
      var pillsHtml = "";
      // Angeheftete Karten (z.B. Lasuren) als ERSTE Pills — auch ohne Manifest-Eintrag.
      var pinnedSeen = {};
      pinnedCards.forEach(function(pc){
        if (!pc || !pc.slug) return;
        pinnedSeen[pc.slug] = 1;
        var isAct = S.currentSlug===pc.slug;
        if (isAct && !cur) curLabel = pc.label || pc.slug;
        pillsHtml += '<button class="ftk-v18__cardpill'+(isAct?" ftk-v18__cardpill--active":"")+'" data-v18="cardpill" data-slug="'+esc(pc.slug)+'" type="button">'+esc(pc.label||pc.slug)+'</button>';
      });
      TOP_CARDS.forEach(function(slug){
        if (pinnedSeen[slug]) return;   // nicht doppelt
        var c = manifestCards.find(function(x){ return x.slug===slug; });
        if (!c) return;
        var isAct = S.currentSlug===slug;
        pillsHtml += '<button class="ftk-v18__cardpill'+(isAct?" ftk-v18__cardpill--active":"")+'" data-v18="cardpill" data-slug="'+esc(slug)+'" type="button">'+esc(c.label||slug)+'</button>';
      });
      return '<div class="ftk-v18__cardchooser">' +
        '<div class="ftk-v18__cardchooser-select" data-v18="cardchooser-toggle" role="button" tabindex="0" aria-haspopup="listbox" aria-expanded="false">' +
          '<span class="ftk-v18__cardchooser-icon">&#9636;</span>' +
          '<span class="ftk-v18__cardchooser-label" data-v18="cardchooser-label">'+esc(curLabel)+'</span>' +
          '<span class="ftk-v18__cardchooser-caret">&#9662;</span>' +
        '</div>' +
        '<div class="ftk-v18__cardchooser-dropdown" data-v18="cardchooser-dropdown" role="listbox" style="display:none">' +
          '<div class="ftk-v18__cardchooser-searchwrap">' +
            '<input type="search" class="ftk-v18__cardchooser-search" data-v18="cardchooser-search" placeholder="Kollektion suchen — z. B. RAL, NCS, Brillux …" autocomplete="off" spellcheck="false" aria-label="Farbtonkarte/Kollektion suchen">' +
          '</div>' +
          '<div class="ftk-v18__cardchooser-list" data-v18="cardchooser-list"></div>' +
        '</div>' +
        '<div class="ftk-v18__cardpills ftk-v18__hide-scroll">'+pillsHtml+'</div>' +
      '</div>';
    }

    function renderCardDropdownList(filterQ) {
      var listEl = q('[data-v18="cardchooser-list"]');
      if (!listEl) return;
      var fq = (filterQ||"").toLowerCase();
      var cards = fq ? manifestCards.filter(function(c){ return (c.label||c.slug).toLowerCase().indexOf(fq)>=0 || (c.slug||"").toLowerCase().indexOf(fq)>=0; }) : manifestCards.slice();
      if (!cards.length) {
        // Sackgasse vermeiden (Review-Befund): wer hier „RAL 7016" o.ä. tippt,
        // meint einen FARBTON — direkten Absprung in die Ton-Suche anbieten.
        listEl.innerHTML = '<div class="ftk-v18__cardchooser-empty">Keine Kollektion gefunden<br>' +
          '<button class="ftk-v18__btn-reset" style="margin-top:8px" data-v18="cardsearch-as-tone" data-q="'+esc(filterQ||"")+'" type="button">„'+esc(filterQ||"")+'&#8220; als Farbton suchen</button></div>';
        return;
      }
      listEl.innerHTML = cards.map(function(c){
        var isAct = c.slug===S.currentSlug;
        return '<div class="ftk-v18__cardchooser-opt'+(isAct?" ftk-v18__cardchooser-opt--active":"")+'" data-v18="cardchooser-opt" data-slug="'+esc(c.slug)+'" role="option" aria-selected="'+(isAct?"true":"false")+'">' +
          '<span>'+esc(c.label||c.slug)+'</span>' +
          (c.count?'<span class="ftk-v18__cardchooser-opt-count">'+esc(c.count)+'</span>':'') +
        '</div>';
      }).join("");
    }

    function openCardDropdown() {
      var dd = q('[data-v18="cardchooser-dropdown"]');
      var tog = q('[data-v18="cardchooser-toggle"]');
      if (!dd) return;
      renderCardDropdownList("");
      dd.style.display = "flex"; // flex-column (sonst greift die Scroll-Begrenzung der Liste nicht)
      if (tog) tog.setAttribute("aria-expanded","true");
      S.cardDropdownOpen = true;
      var si = q('[data-v18="cardchooser-search"]');
      if (si) { si.value=""; setTimeout(function(){ try{si.focus();}catch(e){} },0); }
      var actOpt = dd.querySelector(".ftk-v18__cardchooser-opt--active");
      if (actOpt) setTimeout(function(){ try{ actOpt.scrollIntoView({block:"center"}); }catch(e){} },0);
    }

    function closeCardDropdown() {
      var dd = q('[data-v18="cardchooser-dropdown"]');
      var tog = q('[data-v18="cardchooser-toggle"]');
      if (dd) dd.style.display = "none";
      if (tog) tog.setAttribute("aria-expanded","false");
      S.cardDropdownOpen = false;
    }

    function switchCard(slug) {
      if (!slug) { closeCardDropdown(); return; }
      closeCardDropdown();
      if (slug===S.currentSlug) return;
      trackFTK("ftk_card_switch", { from: S.currentSlug || "", to: slug });
      S.displayedCount = GRID_PAGE_SIZE;
      loadCard(slug);
    }

    function buildWheelPanel() {
      var act = S.entry==="farbkreis";
      var wheelHex = hslToHex(S.wheelH, S.wheelS, S.wheelL);
      var nearEl = S.colors.length ? nearestColor(wheelHex, S.colors) : null;
      // Thumb position berechnen
      var r = S.wheelS/100; // 0..1
      var angle = (S.wheelH / 360) * 2 * Math.PI;
      var thumbX = (50 + r*48*Math.cos(angle-Math.PI/2)).toFixed(1)+"%";
      var thumbY = (50 + r*48*Math.sin(angle-Math.PI/2)).toFixed(1)+"%";

      // Vorschau/Thumb zeigen den NÄCHSTEN echten Sto-Ton (nicht den rohen
      // Wheel-Hex) → Nutzer hat das Gefühl, genau diesen Ton gewählt zu haben.
      var showHex = nearEl ? nearEl.hex : wheelHex;
      return '<div class="ftk-v18__panel'+(act?" ftk-v18__panel--active":"")+'" data-v18-panel="farbkreis">' +
        '<div class="ftk-v18__wheel-card">' +
          '<div class="ftk-v18__wheel-container">' +
            '<div class="ftk-v18__wheel" data-v18="wheel">' +
              '<div class="ftk-v18__wheel-white"></div>' +
              '<div class="ftk-v18__wheel-bright" data-v18="wheel-bright"></div>' +
              '<div class="ftk-v18__wheel-thumb" style="left:'+thumbX+';top:'+thumbY+';background:'+esc(showHex)+'"></div>' +
            '</div>' +
            '<div class="ftk-v18__wheel-brightness-wrap">' +
              '<div class="ftk-v18__wheel-brightness-labels"><span>Dunkler</span><span>Helligkeit</span><span>Heller</span></div>' +
              '<input type="range" min="14" max="94" value="'+S.wheelL+'" data-v18="wheel-l">' +
            '</div>' +
          '</div>' +
          '<div class="ftk-v18__wheel-preview-col">' +
            '<div class="ftk-v18__wheel-preview" style="background:'+esc(showHex)+'"></div>' +
            '<div class="ftk-v18__wheel-nearest-label">Nächster Sto-Mischton</div>' +
            '<div class="ftk-v18__wheel-nearest">' +
              '<span class="ftk-v18__wheel-nearest-swatch" style="background:'+(nearEl?esc(nearEl.hex):"#888")+'"></span>' +
              '<div>' +
                '<div class="ftk-v18__wheel-nearest-code">'+(nearEl?esc(nearEl.name):"-")+'</div>' +
                '<div class="ftk-v18__wheel-nearest-name">'+(nearEl?esc(nearEl.id):"-")+'</div>' +
              '</div>' +
            '</div>' +
            '<button class="ftk-v18__btn-choose-wheel" data-v18="choose-wheel">Diesen Ton wählen &#8594;</button>' +
          '</div>' +
        '</div>' +
        // #3: Raum-/Fassaden-Vorschau direkt unter dem Farbkreis (nur Desktop,
        // per CSS) — zeigt live den nächsten Sto-Mischton in echten Szenen.
        '<div class="ftk-v18__wheel-viz" data-v18="wheel-viz" aria-label="Raumvorschau"></div>' +
      '</div>';
    }

    function buildMoodsPanel() {
      var act = S.entry==="stimmungen";
      var html = '<div class="ftk-v18__panel'+(act?" ftk-v18__panel--active":"")+'" data-v18-panel="stimmungen">' +
        '<div class="ftk-v18__moods-grid">';
      MOODS.forEach(function(m) {
        var stripeHtml = m.palette.map(function(hex){
          return '<span class="ftk-v18__mood-stripe-seg" style="background:'+esc(hex)+';"></span>';
        }).join("");
        var swatchHtml = m.palette.map(function(hex) {
          return '<button class="ftk-v18__mood-swatch" data-v18="mood-swatch" data-hex="'+esc(hex)+'" style="background:'+esc(hex)+'" title="'+esc(hex)+'"></button>';
        }).join("");
        html += '<div class="ftk-v18__mood-card">' +
          '<div class="ftk-v18__mood-stripe">'+stripeHtml+'</div>' +
          '<div class="ftk-v18__mood-body">' +
            '<div class="ftk-v18__mood-title">'+esc(m.label)+'</div>' +
            '<div class="ftk-v18__mood-desc">'+esc(m.desc)+'</div>' +
            '<div class="ftk-v18__mood-swatches">'+swatchHtml+'</div>' +
          '</div>' +
        '</div>';
      });
      html += '</div></div>';
      return html;
    }

    function buildGuidedPanel() {
      var act = S.entry==="gefuehrt";
      var RAUM_OPTS = ["Wohnzimmer","Schlafzimmer","Küche & Bad","Kinderzimmer","Fassade"];
      var STIMM_OPTS = ["Ruhig & Natürlich","Warm & Gemütlich","Frisch & Hell","Kräftig & Mutig","Erdig & Warm"];
      var HELL_OPTS = ["Hell","Mittel","Dunkel"];

      function chips(opts, key) {
        return opts.map(function(o) {
          var isAct = S["g"+key]===o;
          return '<button class="ftk-v18__guided-chip'+(isAct?" ftk-v18__guided-chip--active":"")+'" data-v18="guided-chip" data-key="'+esc(key)+'" data-val="'+esc(o)+'">'+esc(o)+'</button>';
        }).join("");
      }

      return '<div class="ftk-v18__panel'+(act?" ftk-v18__panel--active":"")+'" data-v18-panel="gefuehrt">' +
        '<div class="ftk-v18__guided-card">' +
          '<div class="ftk-v18__guided-grid">' +
            '<div>' +
              '<div class="ftk-v18__guided-step-label"><span class="ftk-v18__step-badge">1</span>Was streichst du?</div>' +
              '<div class="ftk-v18__guided-chips">'+chips(RAUM_OPTS,"Raum")+'</div>' +
            '</div>' +
            '<div>' +
              '<div class="ftk-v18__guided-step-label"><span class="ftk-v18__step-badge">2</span>Welche Stimmung?</div>' +
              '<div class="ftk-v18__guided-chips">'+chips(STIMM_OPTS,"Stimmung")+'</div>' +
            '</div>' +
            '<div>' +
              '<div class="ftk-v18__guided-step-label"><span class="ftk-v18__step-badge">3</span>Wie hell?</div>' +
              '<div class="ftk-v18__guided-chips">'+chips(HELL_OPTS,"Hell")+'</div>' +
            '</div>' +
            '<button class="ftk-v18__btn-guided-apply" data-v18="guided-apply">Passende Farbtöne zeigen &#8594;</button>' +
          '</div>' +
        '</div>' +
      '</div>';
    }

    function buildResultsSection() {
      return '<section class="ftk-v18__results-section">' +
        '<div class="ftk-v18__results-header">' +
          '<h2 class="ftk-v18__h2">Farbtöne</h2>' +
          '<span class="ftk-v18__result-count" data-v18="result-count">Lade...</span>' +
          '<button class="ftk-v18__btn-favs" data-v18="open-fav" type="button" aria-label="Meine Merkliste ansehen">' +
            HEART_SVG +
            '<span>Favoriten</span>' +
            '<span class="ftk-v18__fav-count-badge" data-v18="fav-count" style="display:'+(S.favs.length?"":"none")+'">'+(S.favs.length||"")+'</span>' +
          '</button>' +
          buildGridSizeControls() +
        '</div>' +
        // Filter kompakt rechts unter der "Farbtöne"-Zeile (Owner-Wunsch):
        // Familie + Helligkeit + Preisstufe.
        '<div class="ftk-v18__results-filters">' +
          buildFamilyChips() +
          buildFilterToolbar() +
        '</div>' +
        '<div class="ftk-v18__swatch-grid ftk-v18__swatch-grid--'+esc(S.gridSize)+'" data-v18="swatch-grid"></div>' +
        '<div class="ftk-v18__load-more-wrap" data-v18="load-more-wrap" style="display:none">' +
          '<button class="ftk-v18__btn-load-more" data-v18="load-more">Weitere Töne laden</button>' +
        '</div>' +
      '</section>';
    }

    // P4 (a): Kachelgröße-Umschalter 3-stufig (Icons aus V17 übernommen)
    function gridSizeIcon(kind) {
      if (kind === "mini")  return '<svg width="15" height="15" viewBox="0 0 16 16" aria-hidden="true"><g fill="currentColor"><rect x="1" y="1" width="3" height="3"/><rect x="6" y="1" width="3" height="3"/><rect x="11" y="1" width="3" height="3"/><rect x="1" y="6" width="3" height="3"/><rect x="6" y="6" width="3" height="3"/><rect x="11" y="6" width="3" height="3"/><rect x="1" y="11" width="3" height="3"/><rect x="6" y="11" width="3" height="3"/><rect x="11" y="11" width="3" height="3"/></g></svg>';
      if (kind === "large") return '<svg width="15" height="15" viewBox="0 0 16 16" aria-hidden="true"><g fill="currentColor"><rect x="1" y="1" width="6" height="6"/><rect x="9" y="1" width="6" height="6"/><rect x="1" y="9" width="6" height="6"/><rect x="9" y="9" width="6" height="6"/></g></svg>';
      return '<svg width="15" height="15" viewBox="0 0 16 16" aria-hidden="true"><g fill="currentColor"><rect x="1" y="1" width="4" height="4"/><rect x="6" y="1" width="4" height="4"/><rect x="11" y="1" width="4" height="4"/><rect x="1" y="6" width="4" height="4"/><rect x="6" y="6" width="4" height="4"/><rect x="11" y="6" width="4" height="4"/><rect x="1" y="11" width="4" height="4"/><rect x="6" y="11" width="4" height="4"/><rect x="11" y="11" width="4" height="4"/></g></svg>';
    }
    function buildGridSizeControls() {
      function b(kind,label){
        var on=S.gridSize===kind;
        return '<button class="ftk-v18__gridsize-btn'+(on?" ftk-v18__gridsize-btn--active":"")+'" data-v18="grid-size" data-size="'+esc(kind)+'" type="button" aria-label="Kacheln '+esc(label)+'" aria-pressed="'+(on?"true":"false")+'">'+gridSizeIcon(kind)+'</button>';
      }
      return '<div class="ftk-v18__gridsize" role="group" aria-label="Kachelgröße">'+b("mini","klein")+b("normal","normal")+b("large","groß")+'</div>';
    }

    // P4 (b): Helligkeits-Slider + PC-Preisstufen-Filter
    function buildFilterToolbar() {
      // Preisstufen-Filter vorerst ausgeblendet (Owner). Helligkeit über volle Breite.
      return '<div class="ftk-v18__filter-toolbar">' +
        '<div class="ftk-v18__filter-group ftk-v18__filter-group--bright">' +
          '<span class="ftk-v18__filter-label">Helligkeit <span class="ftk-v18__filter-hint" data-v18="bright-hint">'+(S.brightnessActive?(S.brightness<50?"dunkler":"heller"):"alle")+'</span></span>' +
          '<input type="range" class="ftk-v18__bright-slider" data-v18="bright-slider" min="0" max="100" step="1" value="'+S.brightness+'" aria-label="Helligkeit filtern">' +
          '<button class="ftk-v18__bright-reset" data-v18="bright-reset" type="button" style="display:'+(S.brightnessActive?"":"none")+'">Zurücksetzen</button>' +
        '</div>' +
      '</div>';
    }

    function buildFamilyChips() {
      var html = '<div class="ftk-v18__family-chips ftk-v18__hide-scroll">';
      FAMILY_LIST.forEach(function(f) {
        var isAct = S.family===f.id;
        var dot = f.swatch ? '<span class="ftk-v18__family-dot" style="background:'+esc(f.swatch)+'"></span>' : "";
        html += '<button class="ftk-v18__family-chip'+(isAct?" ftk-v18__family-chip--active":"")+'" data-v18="family-chip" data-family="'+esc(f.id)+'">'+dot+esc(f.label)+'</button>';
      });
      html += '</div>';
      return html;
    }

    function buildTrustStrip() {
      return '<section class="ftk-v18__trust-strip">' +
        '<div class="ftk-v18__trust-strip-inner">' +
          '<div class="ftk-v18__trust-strip-cta-row">' +
            '<div>' +
              '<div class="ftk-v18__trust-strip-heading">Unsicher? Frag Malermeister Thomas.</div>' +
              '<div class="ftk-v18__trust-strip-sub">Über 35 Jahre Erfahrung. Wir sagen dir kostenlos, welcher Ton & welches Produkt zu deinem Projekt passt — und mischen exakt nach.</div>' +
            '</div>' +
            '<div class="ftk-v18__trust-strip-btns">' +
              '<button class="ftk-v18__btn-beratung-strip" data-v18="contact">Kostenlose Beratung</button>' +
              '<button class="ftk-v18__btn-merkliste-strip" data-v18="open-fav">Merkliste ansehen</button>' +
            '</div>' +
          '</div>' +
          '<div class="ftk-v18__trust-strip-divider"></div>' +
          '<div class="ftk-v18__trust-item"><span class="ftk-v18__trust-icon">&#9733;</span><div><div class="ftk-v18__trust-item-main">4,9 / 5 Sterne</div><div class="ftk-v18__trust-item-sub">' + TRUST_REVIEWS + ' Bewertungen</div></div></div>' +
          '<div class="ftk-v18__trust-item"><span class="ftk-v18__trust-icon">&#9201;</span><div><div class="ftk-v18__trust-item-main">Versand in 24 h</div><div class="ftk-v18__trust-item-sub">bestell bis 14:00 Uhr</div></div></div>' +
          '<div class="ftk-v18__trust-item"><span class="ftk-v18__trust-icon">&#8364;</span><div><div class="ftk-v18__trust-item-main">Bestpreis-Garantie</div><div class="ftk-v18__trust-item-sub">100 % original Sto</div></div></div>' +
          '<div class="ftk-v18__trust-item"><span class="ftk-v18__trust-icon">&#9993;</span><div><div class="ftk-v18__trust-item-main">Gratis ab 149 €</div><div class="ftk-v18__trust-item-sub">deutschlandweit</div></div></div>' +
        '</div>' +
      '</section>';
    }

    // ============================================================
    // DATA
    // ============================================================
    // PDP-Modus: Liste auf Töne reduzieren, die im PDP-Produkt tönbar sind.
    // Vor MABA-Ready (oder ohne PDP) unverändert; das Grid wird so lange gegated.
    function pdpFilter(list) {
      if (!S.pdpMode || !S.pdpSku) return list;          // Standalone: unverändert
      // PDP vor MABA-Ready: NICHTS durchlassen (eine Quelle für Grid, Suche,
      // Farbkreis-Nächster UND Harmonien) → kein nicht-tönbarer Ton blitzt auf.
      if (!S.mabaReady) return [];
      var FTK = global.FTK;
      if (!FTK || typeof FTK.isColorCompatibleWithProduct !== "function") return list;
      return (list || []).filter(function(c){
        // Töne mit unbekannter Preisklasse (tc=99, 145 Töne in 17 Karten) im
        // PDP nicht anbieten — sonst würden sie still zum PC1-Preis übernommen.
        if (c.toneClass != null && String(c.toneClass) === "99") return false;
        // Kartenübergreifende Suchtreffer aus Karten ohne Tönbarkeitsdaten
        // (fail-open) nicht anbieten. Bewusst NUR für Worker-Treffer (_global,
        // c.card = Slug) — die aktiv geladene Karte ist über den gefilterten
        // Karten-Umschalter bereits abgesichert (c.card wäre dort das Label).
        if (mabaCoveredCards && c._global && c.card && !mabaCoveredCards[c.card]) return false;
        return FTK.isColorCompatibleWithProduct(c.id, S.pdpSku);
      });
    }

    // Request-Token (loadSeq, oben initialisiert) gegen Out-of-order-Responses:
    // bei schnellem Kartenwechsel gewinnt sonst die zuletzt AUFGELÖSTE statt
    // der zuletzt GEWÄHLTEN Karte (Sikkens 1 MB vs. kleine Karten <10 KB).
    function loadCard(slug) {
      var myId = ++loadSeq;
      S.loading = true;
      updateResultCount("Lade…");
      global.FTK.loadCard(slug).then(function(cols) {
        if (myId !== loadSeq) return;   // veralteter Response — andere Karte gewählt
        S.rawColors = cols||[];
        S.colors = pdpFilter(S.rawColors);
        S.currentSlug = slug;
        S.displayedCount = GRID_PAGE_SIZE;
        S.loading = false;
        renderCardChooser();
        renderGrid();
        syncUrlState();
        // Wheel-Nearest aktualisieren
        if (q('[data-v18-panel="farbkreis"]')) rerenderWheelNearest();
        // Deep-Link von einer Farbtonkarte: gewünschten Ton einmalig als Modal öffnen
        if (pendingOpenTon) {
          var wantTon = _tonKey(pendingOpenTon);
          pendingOpenTon = "";
          var hitTon = (S.colors || []).find(function(x){ return _tonKey(x.id) === wantTon; });
          if (hitTon) { try { openModal(hitTon); } catch(e){} }
        }
      }).catch(function(e) {
        if (myId !== loadSeq) return;
        console.error("[FTKV18] loadCard Fehler:", e);
        S.loading = false;
        updateResultCount("Fehler beim Laden");
        // Handlungsleitender Leerzustand statt stehen bleibendem Alt-Grid
        var grid = q('[data-v18="swatch-grid"]');
        if (grid) grid.innerHTML = '<div class="ftk-v18__empty">' +
          '<div class="ftk-v18__empty-title">Karte konnte nicht geladen werden</div>' +
          '<div class="ftk-v18__empty-text">Prüf kurz deine Verbindung und versuch es nochmal.</div>' +
          '<button class="ftk-v18__btn-reset" data-v18="retry-card" data-slug="'+esc(slug)+'">Nochmal versuchen</button>' +
        '</div>';
      });
    }

    // URL spiegelt Karte + geöffneten Ton (?card=&ton=) — Reload/Teilen/Zurück
    // reproduzieren so den Zustand (Standalone; im PDP-Modal bleibt die URL unberührt).
    function syncUrlState() {
      if (S.pdpMode) return;
      try {
        var u = new URL(global.location.href);
        if (S.currentSlug) u.searchParams.set("card", S.currentSlug);
        if (S.sel && S.sel.id) u.searchParams.set("ton", S.sel.id); else u.searchParams.delete("ton");
        global.history.replaceState({}, "", u.toString());
      } catch(e){}
    }

    // Globale Worker-Treffer auf das interne Farbschema mappen (Felder: i,n,h,c,pc,tc)
    function mapGlobalResults() {
      var fixU = (global.FTK && global.FTK.fixUmlautDisplay) || function(x){ return x; };
      return (S.globalResults||[]).map(function(r){
        return {
          id: r.i || r.id || r.code || "",
          name: fixU(r.n || r.name || r.i || r.id || ""),
          hex: r.h || r.hex || "#888888",
          card: r.c || r.card || "",
          priceClass: r.pc || null,
          toneClass: (r.tc != null ? String(r.tc) : (r.toneClass || "")),
          _global: true // Worker-Treffer: card = Slug (für den Coverage-Filter)
        };
      });
    }

    // Karten-Slug → lesbares Label. Erst aus dem Manifest, sonst humanisieren
    // ("ral-farbtonkarte" → "RAL Farbtonkarte").
    function cardLabel(slug) {
      if (!slug) return "";
      var titleCase = function(str){
        return String(str).split(/[\s-]+/).map(function(w){
          if (!w) return w;
          if (/^(ral|ncs|pc|sto)$/i.test(w)) return w.toUpperCase();
          return w.charAt(0).toUpperCase()+w.slice(1).toLowerCase();
        }).join(" ");
      };
      var m = manifestCards.find(function(c){ return c.slug===slug; });
      if (m && m.label) {
        // Schrei-Großschreibung ("RAL FARBTONKARTE") in Titelschreibung wandeln,
        // gut formatierte Labels ("StoColor System 2022") unverändert lassen.
        return /[a-z]/.test(m.label) ? m.label : titleCase(m.label);
      }
      return titleCase(slug);
    }

    // Farbe per ID auflösen — erst aktuelle Karte, dann globale Treffer.
    // (Klick auf einen kartenübergreifenden Treffer muss das Modal öffnen.)
    function findColorById(id) {
      var c = S.colors.find(function(x){ return x.id===id; });
      if (c) return c;
      return mapGlobalResults().find(function(x){ return x.id===id; }) || null;
    }

    function getFilteredColors() {
      var q2 = norm(S.query);

      // Fix 3 (Owner): aktive Suche durchsucht ALLE Farbtonkarten und ignoriert
      // sämtliche Filter (Familie/Helligkeit/PC/Slider).
      if (q2) {
        var q2c = q2.replace(/\s/g,"");
        var sortExactFirst = function(list){
          var exact=[], rest=[];
          list.forEach(function(c){
            (norm(String(c.id)).replace(/\s/g,"")===q2c || norm(c.name)===q2) ? exact.push(c) : rest.push(c);
          });
          return exact.concat(rest);
        };
        // Sobald der Worker geantwortet hat: dessen KARTENÜBERGREIFENDE Treffer
        // zeigen (nicht mit der aktiven Karte vermischen — sonst verdrängen viele
        // lokale Treffer die anderen Karten von der ersten Seite).
        if (S.globalMode && S.globalResults.length) {
          // PDP-Modus: kartenübergreifende Treffer ebenfalls auf tönbare reduzieren.
          return sortExactFirst(pdpFilter(mapGlobalResults()));
        }
        // Bis der Worker antwortet (oder als Fallback ohne Worker): lokale Karte
        // als Sofort-Platzhalter durchsuchen.
        var hits = S.colors.filter(function(c) {
          return norm(c.name).indexOf(q2)!==-1 ||
                 norm(c.id).indexOf(q2)!==-1 ||
                 norm(String(c.id).replace(/\s/g,"")).indexOf(q2c)!==-1 ||
                 (c.card && norm(c.card).indexOf(q2)!==-1);
        });
        return sortExactFirst(hits);
      }

      var cols = S.colors;
      // Kollektions-Filter (aus Search-Panel)
      // Karten haben alle denselben Slug — Kollektions-Filter hier ist Tab-"Fächer"
      // (dieser Filter wechselt die geladene Karte, nicht ein clientseitiger Filter)

      // Familie
      if (S.family!=="alle") {
        cols = cols.filter(function(c){ return colorFamilyId(c)===S.family; });
      }

      // Helligkeits-Filter (aus Geführt)
      if (S.helFilter==="hell") {
        cols = cols.filter(function(c){ var rgb=hexToRgb(c.hex); var hsl=rgbToHsl(rgb.r,rgb.g,rgb.b); return hsl.l>=0.72; });
      } else if (S.helFilter==="mittel") {
        cols = cols.filter(function(c){ var rgb=hexToRgb(c.hex); var hsl=rgbToHsl(rgb.r,rgb.g,rgb.b); return hsl.l>=0.46&&hsl.l<0.78; });
      } else if (S.helFilter==="dunkel") {
        cols = cols.filter(function(c){ var rgb=hexToRgb(c.hex); var hsl=rgbToHsl(rgb.r,rgb.g,rgb.b); return hsl.l<=0.50; });
      }

      // P4: Helligkeits-Slider (V17-Logik: 0=dunkel … 100=hell, ±-Toleranzbänder)
      if (S.brightnessActive) {
        var bright = S.brightness/100;
        if (bright<=0.4) {
          var maxL = 0.35 + bright*0.5;
          cols = cols.filter(function(c){ return hexLuminance(c.hex) < maxL; });
        } else if (bright>=0.6) {
          var minL = 0.45 + (bright-0.6)*1.1;
          cols = cols.filter(function(c){ return hexLuminance(c.hex) > Math.min(minL,0.9); });
        }
      }

      // P4: PC-Preisstufen-Filter (nur wenn mind. eine Stufe abgewählt)
      var pcActive = Object.keys(S.pcFilter).some(function(k){ return !S.pcFilter[k]; });
      if (pcActive) {
        cols = cols.filter(function(c){ return !c.priceClass || S.pcFilter[c.priceClass]!==false; });
      }

      return cols;
    }

    // Globale (kartenübergreifende) Suche anstoßen — wie V17 triggerGlobalSearch.
    // Lokale Treffer zeigt renderGrid sofort; globale ersetzen, sobald da.
    function triggerGlobalSearch(query) {
      if (!global.FTK || !global.FTK.searchGlobal) return;
      if (S.globalAbort) { try { S.globalAbort.abort(); } catch(e){} }
      S.globalAbort = (typeof AbortController!=="undefined") ? new AbortController() : null;
      var signal = S.globalAbort ? S.globalAbort.signal : undefined;
      var qSent = String(query||"").trim().toLowerCase();
      global.FTK.searchGlobal(query, 60, signal).then(function(data){
        // Nur anwenden, wenn die Suche noch aktuell ist
        if (String(S.query||"").trim().toLowerCase() !== qSent) return;
        if (!data || !Array.isArray(data.results) || !data.results.length) {
          if (S.globalMode) { S.globalMode=false; S.globalResults=[]; renderGrid(); }
          return;
        }
        S.globalMode = true;
        S.globalResults = data.results;
        renderGrid();
        // PDP-Modus: Treffer stammen aus NICHT geladenen Karten — deren
        // Sperrlisten fehlen im skuOnly-Datensatz (fail-open). Voll-Datei
        // nachziehen und die Trefferliste nachfiltern (Review-Befund).
        if (S.pdpMode && global.FTK.triggerMabaLoad) {
          global.FTK.triggerMabaLoad().then(function(){
            if (S.globalMode && String(S.query||"").trim().toLowerCase() === qSent) renderGrid();
          }).catch(function(){});
        }
      }).catch(function(){});
    }

    function cancelGlobalSearch() {
      if (S.globalAbort) { try { S.globalAbort.abort(); } catch(e){} S.globalAbort=null; }
      S.globalMode = false;
      S.globalResults = [];
    }

    // ============================================================
    // RENDER
    // ============================================================
    function renderGrid() {
      var grid = q('[data-v18="swatch-grid"]');
      var lmw = q('[data-v18="load-more-wrap"]');
      if (!grid) return;

      // PDP-Modus: erst anzeigen, wenn die Tönbarkeit (MABA) geladen ist —
      // sonst würden kurz auch nicht-tönbare Töne aufblitzen.
      if (S.pdpMode && !S.mabaReady) {
        updateResultCount("Prüfe tönbare Farbtöne …");
        grid.innerHTML = '<div class="ftk-v18__empty"><div class="ftk-v18__empty-text">Tönbare Farbtöne werden geladen …</div></div>';
        if (lmw) lmw.style.display = "none";
        return;
      }

      var filtered = getFilteredColors();

      if (norm(S.query)) {
        updateResultCount(filtered.length+" Treffer für „"+esc(S.query.trim())+"“"+(S.globalMode?" aus allen Karten":"")+" · Filter während der Suche ausgeblendet");
      } else {
        updateResultCount(filtered.length+" Töne · tippe für Raumvorschau & Produkt");
      }

      if (!filtered.length) {
        // Null-Treffer-Suchen tracken (einmal je Query, nicht je Tastendruck)
        if (norm(S.query) && S._lastZeroQ !== S.query) {
          S._lastZeroQ = S.query;
          trackFTK("ftk_search_zero_results", { query: S.query.trim(), card: S.currentSlug || "", global_mode: !!S.globalMode });
        }
        var emptyTitle, emptyText;
        if (S.pdpMode && !S.query) {
          emptyTitle = "Kein tönbarer Ton in dieser Kollektion";
          emptyText  = "Für dein Produkt ist aus dieser Kollektion kein Farbton tönbar — wähle oben eine andere Kollektion.";
        } else {
          emptyTitle = "Kein Treffer" + (S.query?' für „'+esc(S.query)+'\"':'');
          emptyText  = S.pdpMode ? "In dieser Kollektion kein tönbarer Ton dazu — probier einen anderen Code/Namen oder wechsle oben die Kollektion." : "Probier einen anderen Code, Namen oder lösche den Filter.";
        }
        grid.innerHTML = '<div class="ftk-v18__empty">' +
          '<div class="ftk-v18__empty-title">'+emptyTitle+'</div>' +
          '<div class="ftk-v18__empty-text">'+emptyText+'</div>' +
          (S.pdpMode ? '' : '<button class="ftk-v18__btn-reset" data-v18="reset-filters">Filter zurücksetzen</button>') +
        '</div>';
        if (lmw) lmw.style.display="none";
        return;
      }

      var visible = filtered.slice(0, S.displayedCount);
      grid.innerHTML = visible.map(tileHtml).join("");

      if (lmw) lmw.style.display = (S.displayedCount < filtered.length) ? "" : "none";
    }

    // Preis der Tönstufe schon VOR der Übernahme zeigen (Review-Befund: der
    // PC-Aufpreis war erst nach dem Commit in der Buybox sichtbar). Liest die
    // Preise aus den mitgegebenen PDP-Varianten; bei Unsicherheit leer.
    function pdpCommitPriceHtml(c) {
      try {
        var vs = (pdpProduct && pdpProduct.variants) || [];
        if (!vs.length || !c) return "";
        var fw = isFertigWeiss(c.id);
        var tcP = c.toneClass != null ? String(c.toneClass) : "";
        var pcP = "";
        if (!fw) {
          var pr = c.priceClass || (global.FTK.normalizePriceClass ? global.FTK.normalizePriceClass(tcP) : "");
          pcP = pr ? String(parseInt(pr, 10) || "") : (tcP === "0" ? "1" : "");
        }
        var match = vs.filter(function(v){
          var o1 = String(v.option1 || "");
          if (fw) return /wei(ß|ss)/i.test(o1);
          return pcP ? o1.indexOf("PC" + pcP) > -1 : false;
        });
        if (!match.length && pcP) match = vs.filter(function(v){ return /get(ö|oe)nt/i.test(String(v.option1 || "")); });
        var prices = match.map(function(v){ return typeof v.price === "number" ? v.price : parseInt(v.price, 10); })
                          .filter(function(n){ return isFinite(n) && n > 0; });
        if (!prices.length) return "";
        var eur = (Math.min.apply(null, prices) / 100).toFixed(2).replace(".", ",") + " €";
        var lbl = fw ? "zum Weiß-Preis" : (pcP ? "Preisstufe PC" + pcP : "");
        return '<div class="ftk-v18__pdp-commit-price" style="margin-top:6px;font-size:13.5px;color:#1a1a1a"><b>ab ' + eur + '</b>' + (lbl ? ' <span style="color:#64748B">&middot; ' + lbl + '</span>' : '') + '</div>';
      } catch(e) { return ""; }
    }

    // Einzelne Grid-Kachel — von renderGrid UND appendMoreTiles genutzt.
    function tileHtml(c) {
      var light = isLightHex(c.hex);
      var textColor = light ? "#23201A" : "#FFFFFF";
      var metaClass = light ? "" : " ftk-v18__tile-meta--dark";
      var favActive = isFav(c.id) ? " ftk-v18__tile-heart--active" : "";
      var label = tileLabel(c);
      return '<button class="ftk-v18__tile" data-v18="tile" data-id="'+esc(c.id)+'" ' +
        'style="background:'+esc(c.hex)+'" aria-label="'+esc(c.id)+(label?" "+esc(label):"")+'">' +
        '<span class="ftk-v18__tile-heart'+favActive+'" data-v18="tile-fav" data-id="'+esc(c.id)+'" data-hex="'+esc(c.hex)+'" data-name="'+esc(c.name)+'">'+HEART_SVG+'</span>' +
        '<span class="ftk-v18__tile-meta'+metaClass+'" style="color:'+textColor+'">' +
          '<span class="ftk-v18__tile-code">'+esc(c.id)+'</span>' +
          (label ? '<span class="ftk-v18__tile-name">'+esc(label)+'</span>' : '') +
        '</span>' +
      '</button>';
    }

    // „Weitere Töne laden": nur das NEUE Slice anhängen statt das komplette
    // Grid per innerHTML neu zu bauen (Jank bei großen Karten wie Sikkens 8.442).
    function appendMoreTiles() {
      var grid = q('[data-v18="swatch-grid"]');
      var lmw = q('[data-v18="load-more-wrap"]');
      if (!grid) return;
      var filtered = getFilteredColors();
      var from = S.displayedCount;
      S.displayedCount += GRID_PAGE_MORE;
      grid.insertAdjacentHTML("beforeend", filtered.slice(from, S.displayedCount).map(tileHtml).join(""));
      if (lmw) lmw.style.display = (S.displayedCount < filtered.length) ? "" : "none";
    }

    // Aktiven Zustand des Karten-Choosers (Dropdown-Label + Top-8-Pills) angleichen
    function renderCardChooser() {
      // Aktuelles Karten-Label im Dropdown-Trigger
      var cur = manifestCards.find(function(c){ return c.slug===S.currentSlug; });
      var pin = cur ? null : pinnedCards.find(function(p){ return p && p.slug===S.currentSlug; });
      var lblEl = q('[data-v18="cardchooser-label"]');
      if (lblEl) lblEl.textContent = cur ? (cur.label||cur.slug) : (pin ? (pin.label||pin.slug) : (cardLabel(S.currentSlug) || "Farbtonkarte wählen"));
      // Top-8-Pills aktiv markieren
      qa(".ftk-v18__cardpill").forEach(function(el){
        el.classList.toggle("ftk-v18__cardpill--active", el.getAttribute("data-slug")===S.currentSlug);
      });
    }

    function updateResultCount(text) {
      var el = q('[data-v18="result-count"]');
      if (el) el.textContent = text;
    }

    function updateFavBadge() {
      var n = S.favs.length;
      qa('[data-v18="fav-count"]').forEach(function(el){
        el.textContent = n>0?String(n):"";
        el.style.display = n>0?"":"none";
      });
    }

    function rerenderWheelNearest() {
      var wheelHex = hslToHex(S.wheelH, S.wheelS, S.wheelL);
      var near = S.colors.length ? nearestColor(wheelHex, S.colors) : null;
      var panel = q('[data-v18-panel="farbkreis"]');
      if (!panel) return;
      var sw = panel.querySelector(".ftk-v18__wheel-nearest-swatch");
      var code = panel.querySelector(".ftk-v18__wheel-nearest-code");
      var name = panel.querySelector(".ftk-v18__wheel-nearest-name");
      var preview = panel.querySelector(".ftk-v18__wheel-preview");
      var thumb = panel.querySelector(".ftk-v18__wheel-thumb");
      var showHex = (near && isValidHex(near.hex)) ? near.hex : wheelHex;
      if (sw) sw.style.background = near?near.hex:"#888";
      if (code) code.textContent = near?near.name:"-";
      if (name) name.textContent = near?near.id:"-";
      if (preview) preview.style.background = showHex;   // großer Block = nächster echter Ton
      if (thumb) thumb.style.background = showHex;
      // Thumb position
      var r = S.wheelS/100;
      var angle = (S.wheelH/360)*2*Math.PI;
      var tx = (50+r*48*Math.cos(angle-Math.PI/2)).toFixed(1)+"%";
      var ty = (50+r*48*Math.sin(angle-Math.PI/2)).toFixed(1)+"%";
      if (thumb) { thumb.style.left=tx; thumb.style.top=ty; }
      applyWheelBrightness(panel);
      // #3: eingebettete Szenen-Vorschau DIREKT mitfärben (kein künstlicher
      // Delay → Bilder ändern sich live beim Drehen). setColor ist intern
      // rAF-gedrosselt, daher sind synchrone Aufrufe pro Move günstig.
      if (S.wheelVizController) syncWheelViz(showHex, near?(near.name||near.id):"");
      else tryMountWheelViz();
    }

    // Ganzer Farbkreis wird heller/dunkler (nicht nur der aktive Punkt):
    // weiße bzw. schwarze Überlagerung je nach Helligkeit (S.wheelL 14..94).
    function applyWheelBrightness(scope) {
      var el = (scope||rootEl).querySelector('[data-v18="wheel-bright"]');
      if (!el) return;
      var L = S.wheelL;
      if (L >= 60) { el.style.background = "#FFFFFF"; el.style.opacity = (Math.min((L-60)/34,1)*0.82).toFixed(3); }
      else         { el.style.background = "#000000"; el.style.opacity = (((60-L)/46)*0.7).toFixed(3); }
    }

    // ════════ #3: Szenen-Vorschau direkt unter dem Farbkreis (nur Desktop) ══
    // Mobil verhindert isWheelVizDesktop() Mount + Asset-Load; CSS blendet den
    // Host zusätzlich aus → kein Visualizer-Script/keine Szenen auf dem Handy.
    function isWheelVizDesktop() {
      try { return global.matchMedia("(min-width:861px)").matches; }
      catch(e) { return (global.innerWidth || 1024) > 860; }
    }

    // Einmaliger Script-Loader; sammelt Callbacks, damit Modal-Visualizer und
    // Farbkreis-Vorschau sich nicht gegenseitig blockieren (gemeinsame Flags).
    function loadVisualizerScript(cb) {
      if (S.visualizerLoaded && global.FTKVisualizer) { if (cb) cb(); return; }
      if (cb) (S._vizCbs = S._vizCbs || []).push(cb);
      if (S.visualizerLoading || !visualizerUrl) return;
      S.visualizerLoading = true;
      var s = document.createElement("script");
      s.src = visualizerUrl; s.async = true;
      s.onload = function(){
        S.visualizerLoaded = true; S.visualizerLoading = false;
        var cbs = S._vizCbs || []; S._vizCbs = [];
        cbs.forEach(function(fn){ try { fn(); } catch(e){} });
      };
      s.onerror = function(){ S.visualizerLoading = false; S._vizCbs = []; };
      document.head.appendChild(s);
    }

    function currentWheelNearest() {
      var wheelHex = hslToHex(S.wheelH, S.wheelS, S.wheelL);
      return S.colors.length ? nearestColor(wheelHex, S.colors) : null;
    }

    // Eager auf Desktop (Farbkreis ist der Default-Tab → Vorschau ist sichtbar
    // gemeint; der Platzhalter „wird geladen" soll nicht hängen bleiben). Auf
    // Mobile verhindert isWheelVizDesktop() Mount + Asset-Load; CSS blendet aus.
    // Resize-Listener fängt den Wechsel Mobil→Desktop ab.
    function setupWheelVizObserver() {
      if (S._wheelVizResizeBound) return;
      S._wheelVizResizeBound = true;
      global.addEventListener("resize", function(){
        if (S._wheelVizRT) clearTimeout(S._wheelVizRT);
        S._wheelVizRT = setTimeout(tryMountWheelViz, 200);
      });
    }

    // Mountet die Vorschau, sobald Desktop + Farbkreis aktiv + Daten/Host bereit.
    function tryMountWheelViz() {
      if (S.wheelVizController || S.wheelVizMounting) return;
      if (!visualizerUrl || !isWheelVizDesktop() || S.entry !== "farbkreis") return;
      var host = q('[data-v18="wheel-viz"]');
      var near = currentWheelNearest();
      if (!host || !near) return; // erneuter Versuch nach Kartenladen/Slider
      S.wheelVizMounting = true;
      loadVisualizerScript(function(){
        S.wheelVizMounting = false;
        var h = q('[data-v18="wheel-viz"]');
        var n = currentWheelNearest();
        if (!h || !n || S.wheelVizController || !global.FTKVisualizer) return;
        if (!isWheelVizDesktop() || S.entry !== "farbkreis") return;
        try {
          S.wheelVizController = global.FTKVisualizer.mount(h, {
            hex: n.hex, name: n.name || n.id || "",
            scene: areaToVizScene(S.area), mode: "scene", assetBase: assetBase
          });
          h.classList.add("ftk-v18__wheel-viz--mounted");
        } catch(e) {}
      });
    }

    // Direktes Umfärben der eingebetteten Vorschau (hex ist hier bereits gültig
    // — Fallback auf den rohen Wheel-Hex passiert in rerenderWheelNearest).
    function syncWheelViz(hex, name) {
      if (!hex || !S.wheelVizController) return;
      try { S.wheelVizController.setColor(hex, name); } catch(e){}
    }

    // TrustedShops-Badge (global, fixed unten rechts) stört auf dieser Seite den
    // Finder → beim Scrollen ausblenden, oben wieder zeigen. Nur hier aktiv
    // (Listener lebt im Finder-JS), andere Shop-Seiten bleiben unberührt.
    function setupTrustBadgeHide() {
      var el = null, hidden = false;
      function find() {
        if (el && document.contains(el)) return el;
        el = document.querySelector('[id^="trustbadge-container"]') ||
             document.getElementById("trustbadge-iframe");
        return el;
      }
      function onScroll() {
        var b = find();
        if (!b) return;
        var y = global.pageYOffset || document.documentElement.scrollTop || 0;
        var shouldHide = y > 30;
        if (shouldHide === hidden) return;
        hidden = shouldHide;
        b.style.transition = "opacity 0.25s ease";
        b.style.opacity = hidden ? "0" : "";
        b.style.pointerEvents = hidden ? "none" : "";
      }
      global.addEventListener("scroll", onScroll, { passive: true });
    }

    // ============================================================
    // DETAIL MODAL
    // ============================================================
    function openModal(color) {
      S.sel = color;
      // priceClass auflösen — globale Suchtreffer tragen keine; ohne sie liefert
      // getCompatibleProducts leer (Produktliste bliebe ewig auf "wird geladen").
      if (!S.sel.priceClass) {
        try {
          var full = global.FTK.getColorById && global.FTK.getColorById(color.id);
          if (full && full.priceClass) S.sel.priceClass = full.priceClass;
          else if (color.toneClass && global.FTK.normalizePriceClass) S.sel.priceClass = global.FTK.normalizePriceClass(color.toneClass);
          // toneClass mitführen (Worker-Suchtreffer tragen keins) → Weiß-Ton-Erkennung
          if (full && full.toneClass != null && full.toneClass !== "") S.sel.toneClass = String(full.toneClass);
        } catch(e) {}
      }
      S.area = "innen";
      S.prodIdx = 0;
      S.gebindeLabel = null;
      S.calcArea = 30;
      S.calcCoats = 2;
      S.vizMode = "farbe";
      S.products = [];
      S.productPool = [];
      S.prodQuery = "";
      S.productsLoaded = false;

      // Produkte SOFORT optimistisch laden (vor MABA) → Liste erscheint ohne
      // Wartezeit. Ist MABA noch nicht da, gilt vorerst alles als machbar; nach
      // dem MABA-Resolve wird verfeinert (nicht-machbare ausgetauscht).
      // PDP-Modus: keine Produktliste (nur das PDP-Produkt) → Produkt-Laden entfällt.
      if (!S.pdpMode) loadProducts();
      renderModal();
      document.body.style.overflow = "hidden";

      var refine = function(){
        if (!(S.sel && S.sel.id === color.id)) return;
        if (!S.pdpMode) { loadProducts(); rerenderProductList(); updateAtcState(); }
      };
      // Produktkatalog lädt asynchron (Storefront-API). Öffnet das Modal vorher,
      // ist die Liste leer → sobald der Katalog bereit ist, neu laden + rendern.
      // (Ohne das blieb es bei "Kein tönbares Produkt", und die Modal-Suche fand nichts.)
      if (!S.pdpMode && global.FTK.onCatalogReady) global.FTK.onCatalogReady(refine);
      // skuOnly reicht hier: die Sperrliste des gewählten Tons steckt in der
      // (ggf. gleich nachgeladenen) Karte; nur der Buybox-Gate lädt die Voll-Datei.
      var mabaReady = global.FTK.triggerMabaLoad ? global.FTK.triggerMabaLoad({ skuOnly: true }) : Promise.resolve();
      if (!S.sel.priceClass && color._global && color.card && global.FTK.loadCard) {
        // Nur für globale Treffer: color.card ist dort der SLUG. Bei Tönen der
        // bereits geladenen Karte ist color.card das LABEL → der Fetch liefe
        // auf 404 und korrumpierte den Out-of-order-Guard (Review-Befund).
        // Cross-Card-Suchtreffer: priceClass fehlt, weil die Karte des Treffers
        // nicht geladen ist → Karte nachladen, dann priceClass + Produkte holen.
        mabaReady.then(function(){ return global.FTK.loadCard(color.card); }).then(function(){
          if (!(S.sel && S.sel.id === color.id)) return;
          try {
            var f2 = global.FTK.getColorById && global.FTK.getColorById(color.id);
            if (f2 && f2.priceClass) S.sel.priceClass = f2.priceClass;
            if (f2 && f2.toneClass != null && f2.toneClass !== "") S.sel.toneClass = String(f2.toneClass);
          } catch(e) {}
          refine();
        }).catch(refine);
      } else {
        mabaReady.then(refine).catch(refine);
      }

      // Fokus ins Modal (A11y): Öffner merken, Schließen-Button fokussieren
      S._modalOpener = document.activeElement;
      var mcBtn = q('[data-v18="modal-close"]');
      if (mcBtn) { try { mcBtn.focus(); } catch(e){} }
      syncUrlState();

      // Tracking (Schema V17)
      trackFTK("ftk_color_selected", { color_id: color.id, hex: color.hex, card: color.card || S.currentSlug });
      trackFTK("ftk_detail_open", { color_id: color.id });
    }

    // Body-Scroll nur entsperren, wenn KEIN PDP-Wrapper-Modal mehr offen ist
    // (sonst würde der Hintergrund hinter dem noch offenen PDP-Modal scrollbar).
    function releaseBodyScroll() {
      if (document.querySelector(".ftkv18m.is-open")) return;
      document.body.style.overflow = "";
    }

    function closeModal() {
      destroyVisualizer();
      closeColorLightbox();
      var slot = q(".ftk-v18__modal-slot");
      if (slot) slot.innerHTML = "";
      S.sel = null;
      releaseBodyScroll();
      syncUrlState();
      // Fokus zurück zum Öffner (A11y)
      if (S._modalOpener && S._modalOpener.focus) { try { S._modalOpener.focus(); } catch(e){} }
      S._modalOpener = null;
    }

    // Einzelnen Farbton groß zeigen (analog zur "Vergrößern"-Funktion bei den
    // Szenen/Fotos). Vollflächige Farbfläche + Code/Name/HEX als Beschriftung.
    function openColorLightbox(color) {
      if (!color || !isValidHex(color.hex)) return;
      closeColorLightbox();
      var rgb = hexToRgb(color.hex);
      var lb = document.createElement("div");
      lb.className = "ftk-v18__clightbox";
      lb.setAttribute("data-v18", "clightbox-overlay");
      lb.setAttribute("role", "dialog");
      lb.setAttribute("aria-modal", "true");
      lb.innerHTML =
        '<div class="ftk-v18__clightbox-panel" style="background:'+esc(color.hex)+'"></div>' +
        '<div class="ftk-v18__clightbox-cap">' +
          '<span class="ftk-v18__clightbox-code">'+esc(color.id)+'</span>' +
          '<span class="ftk-v18__clightbox-name">'+esc(prettyName(color.name||""))+'</span>' +
          '<span class="ftk-v18__clightbox-hex">'+esc(String(color.hex).toUpperCase())+' &middot; RGB '+rgb.r+', '+rgb.g+', '+rgb.b+'</span>' +
        '</div>' +
        '<button class="ftk-v18__clightbox-x" data-v18="clightbox-close" type="button" aria-label="Schließen">&times;</button>';
      (q(".ftk-v18__lightbox-slot") || rootEl).appendChild(lb);
      S.colorLightboxOpen = true;
      trackFTK("ftk_color_enlarge", { color_id: color.id, hex: color.hex });
    }

    function closeColorLightbox() {
      var slot = q(".ftk-v18__lightbox-slot");
      if (slot) slot.innerHTML = "";
      else { var lb = rootEl.querySelector(".ftk-v18__clightbox"); if (lb && lb.parentNode) lb.parentNode.removeChild(lb); }
      S.colorLightboxOpen = false;
    }

    function loadProducts() {
      S.products = []; S.productPool = [];
      if (!S.sel || !global.FTK.getCompatibleProducts) return;
      var area = S.area;
      var sceneId = AREA_PRODUCT_SCENE[area] || "wohnzimmer";
      var wantCats = AREA_PRODUCT_CATS[area] || ["Innenfarben"];
      try {
        var result = global.FTK.getCompatibleProducts(S.sel, sceneId);
        var pool = [];
        (result.categories||[]).forEach(function(cat){
          if (wantCats.indexOf(cat.name) === -1) return;   // nur gewünschte Kategorien
          (cat.products||[]).forEach(function(p){
            if (p.compatible === false) return;            // nur machbare Produkte
            pool.push(Object.assign({}, p, { _cat: cat.name }));
          });
        });
        S.productPool = pool;
        S.products = curateProducts(pool, area);
      } catch(e) {
        S.products = []; S.productPool = [];
      }
      // productsLoaded nur true, wenn der Katalog wirklich geladen ist — sonst zeigt
      // das Leer-State "Produkte werden geladen…" statt fälschlich "kein Produkt tönbar".
      S.productsLoaded = (typeof global.FTK.catalogReady === "boolean") ? global.FTK.catalogReady : true;
      // Katalog-Load fertig, aber fehlgeschlagen → ehrlichen Fehlertext zeigen
      // statt Dauer-"wird geladen" (Review-Befund).
      S.productsFailed = (global.FTK.catalogReady === false && global.FTK.catalogLoading === false);
    }

    // Produkt-Titel matcht bevorzugten Namen: exakt, oder Präfix + Worttrenner
    // (für "StoColor Sil In — Silikatfarbe für innen"). So matcht "StoColor Silco"
    // NICHT "StoColor Silco G".
    function findPreferred(pool, name, used) {
      var n = norm(name);
      var exact = pool.find(function(x){ return !used[x.title] && norm(x.title)===n; });
      if (exact) return exact;
      return pool.find(function(x){
        if (used[x.title]) return false;
        var t = norm(x.title);
        if (t.indexOf(n) !== 0) return false;
        var rest = t.slice(n.length);
        return /^[\s—–-]/.test(rest); // Leerzeichen / Geviert-/Halbgeviertstrich
      });
    }

    // Angezeigte Produktliste: bei Suche gefiltert, sonst die 3 bevorzugten
    // (sofern machbar) + Auffüllen aus dem Bereich.
    function curateProducts(pool, area) {
      var q2 = norm(S.prodQuery);
      if (q2) {
        return pool.filter(function(p){ return norm(p.title).indexOf(q2)!==-1; }).slice(0, 12);
      }
      var pref = PREFERRED_PRODUCTS[area] || [];
      var chosen = [], used = {};
      pref.forEach(function(name){
        var p = findPreferred(pool, name, used);
        if (p) { chosen.push(p); used[p.title] = true; }
      });
      for (var i=0; i<pool.length && chosen.length<3; i++) {
        if (!used[pool[i].title]) { chosen.push(pool[i]); used[pool[i].title]=true; }
      }
      return chosen;
    }

    function renderModal() {
      var slot = q(".ftk-v18__modal-slot");
      if (!slot||!S.sel) return;
      var c = S.sel;
      var rgb = hexToRgb(c.hex);
      // Visualizer-Controller verwerfen — neuer Modal-Inhalt, neue Vorschaufläche.
      destroyVisualizer();
      slot.innerHTML = buildModalHtml(c, rgb);
      attachModalEvents();
    }

    // ── Visualizer-Schnellwahl-Swatches: aktueller Ton + nächste verwandte Töne ──
    // (Owner-Wunsch: Farbe im Foto-/Szenen-Modus direkt wechselbar, wie V17.)
    function buildVizSwatches(color) {
      var swatches = [{ id: color.id, name: color.name, hex: color.hex }];
      var seen = {}; seen[String(color.hex).toUpperCase()] = true;
      try {
        // Harmonien als sinnvolle Nachbartöne (komplementär/analog/neutral)
        getHarmonics(color, S.colors || []).forEach(function(h){
          var nc = h && h.c;
          if (nc && nc.hex && !seen[String(nc.hex).toUpperCase()]) {
            seen[String(nc.hex).toUpperCase()] = true;
            swatches.push({ id: nc.id, name: nc.name, hex: nc.hex });
          }
        });
      } catch(e) {}
      return swatches;
    }

    function destroyVisualizer() {
      if (S.visualizerController) {
        try { S.visualizerController.destroy(); } catch(e) {}
        S.visualizerController = null;
      }
    }

    // V17-Pattern: "Farbe" zeigt den Farbblock; "Im Raum"/"Dein Foto" mounten
    // das echte FTKVisualizer-Modul in dieselbe Fläche (lazy Script-Load).
    function handleVizMode(mode) {
      var slot = q(".ftk-v18__modal-slot");
      if (!slot || !S.sel) return;
      var wrap  = slot.querySelector(".ftk-v18__viz-wrap");
      var block = slot.querySelector(".ftk-v18__viz-color-block");
      if (!wrap) return;
      S.vizMode = mode;

      // Segment-Buttons aktiv schalten
      slot.querySelectorAll('[data-v18="viz-seg"]').forEach(function(b){
        b.classList.toggle("ftk-v18__viz-seg-btn--active", b.getAttribute("data-mode")===mode);
      });

      if (mode === "farbe") {
        wrap.style.display = "none";
        if (block) block.style.display = "";
        trackFTK("ftk_visualizer_open", { mode: mode, hex: S.sel.hex });
        return;
      }
      // Im Raum / Dein Foto: Visualizer ersetzt die Farbblock-Fläche
      if (block) block.style.display = "none";
      wrap.style.display = "";
      trackFTK("ftk_visualizer_open", { mode: mode, hex: S.sel.hex });

      var vizScene = areaToVizScene(S.area);
      if (S.visualizerLoaded && global.FTKVisualizer) {
        mountVisualizer(wrap, S.sel, vizScene, mode);
      } else if (visualizerUrl) {
        wrap.innerHTML = '<div class="ftk-v18__viz-fallback">Lade Visualisierung …</div>';
        loadVisualizerScript(function(){
          // Modal kann zwischenzeitlich geschlossen / Modus gewechselt sein
          var w = q(".ftk-v18__viz-wrap");
          if (w && S.sel && S.vizMode !== "farbe") mountVisualizer(w, S.sel, areaToVizScene(S.area), S.vizMode);
        });
      } else {
        wrap.innerHTML = '<div class="ftk-v18__viz-fallback">Lade Visualisierung …</div>';
      }
    }

    function mountVisualizer(container, color, scene, mode) {
      destroyVisualizer();
      container.innerHTML = "";
      if (global.FTKVisualizer && typeof global.FTKVisualizer.mount === "function") {
        try {
          S.visualizerController = global.FTKVisualizer.mount(container, {
            hex: color.hex,
            name: color.name,
            scene: scene,
            mode: mode === "foto" ? "photo" : "scene",
            assetBase: assetBase,
            swatches: buildVizSwatches(color)
          });
        } catch(e) {
          container.innerHTML = '<div class="ftk-v18__viz-fallback">Visualisierung nicht verfügbar.</div>';
        }
      }
    }

    function buildModalHtml(c, rgb) {
      // Produkte für aktuellen Bereich
      var prods = S.products.slice(0,12);

      // Gebinde aus 1. Produkt
      var gebindeOpts = GEBINDE_SIZES;
      if (!S.gebindeLabel) S.gebindeLabel = gebindeOpts[1]+" L";

      // Preis aus gewähltem Produkt (falls vorhanden)
      var selProd = prods[S.prodIdx]||null;
      var priceLabel = selProd ? (selProd.price||"–") : "–";
      // P3 MABA: ist der gewählte Ton mit dem gewählten Produkt tönbar?
      var atcBlocked = !!selProd && selProd.compatible===false;

      // Rechner — echter Verbrauch des gewählten Produkts (l/m² pro Anstrich)
      var litersRaw = calcLitersRaw(selProd);
      var calcLiters = litersRaw.toFixed(1)+" L";
      var recommend = buildGebindeRecommend(litersRaw);
      var calcCost = selProd ? estimateCost(selProd, litersRaw) : "–";

      // Harmonien
      var harmonics = getHarmonics(c, S.colors);

      // Area pills
      var areaPillsHtml = AREA_PILLS.map(function(a){
        var isAct=S.area===a.id;
        return '<button class="ftk-v18__area-pill'+(isAct?" ftk-v18__area-pill--active":"")+'" data-v18="area-pill" data-area="'+esc(a.id)+'">'+esc(a.label)+'</button>';
      }).join("");

      // Product list
      var prodsHtml = "";
      if (prods.length) {
        prods.forEach(function(p,i){
          var isAct = i===S.prodIdx;
          var incompat = p.compatible===false;
          prodsHtml += '<button class="ftk-v18__product-item'+(isAct?" ftk-v18__product-item--active":"")+(incompat?" ftk-v18__product-incompatible":"")+'" data-v18="prod-item" data-idx="'+i+'">' +
            '<span class="ftk-v18__product-radio"></span>' +
            '<span style="text-align:left;line-height:1.25;flex:1;">' +
              '<span class="ftk-v18__product-name">'+esc(p.title)+(p.isTopPick?'<span class="ftk-v18__product-top-pick">TOP</span>':'')+((incompat)?'<span class="ftk-v18__product-top-pick" style="background:#94A3B8">N/A</span>':'')+'</span>' +
              '<span class="ftk-v18__product-sub">'+esc(p.description ? p.description.slice(0,60) : p._cat||"")+'</span>' +
            '</span>' +
            '<span class="ftk-v18__product-price-from">'+esc(p.price||"")+'</span>' +
          '</button>';
        });
      } else {
        prodsHtml = '<div style="font-size:13px;color:#64748B;padding:12px 0;">Produkte werden geladen…</div>';
      }

      // Gebinde chips
      var gebHtml = gebindeOpts.map(function(l){
        var lbl = l+" L";
        var isAct = S.gebindeLabel===lbl;
        return '<button class="ftk-v18__variant-chip'+(isAct?" ftk-v18__variant-chip--active":"")+'" data-v18="gebinde-chip" data-lbl="'+esc(lbl)+'">' +
          '<span style="font-weight:700">'+esc(lbl)+'</span>' +
        '</button>';
      }).join("");

      // Calc coats
      var coatsHtml = [1,2,3].map(function(n){
        var isAct=S.calcCoats===n;
        return '<button class="ftk-v18__variant-chip'+(isAct?" ftk-v18__variant-chip--active":"")+'" data-v18="coats-chip" data-coats="'+n+'">'+(n===1?"1 Anstrich":n+" Anstriche")+'</button>';
      }).join("");

      // Favs
      var favActive = isFav(c.id);

      // Vorschau-Umschalter: nur noch Farbe / Fotos. "Fotos" mountet das
      // FTKVisualizer-Modul, das intern den Tab „Eigenes Foto" (KI-Wand-
      // erkennung) enthält — ein separater „Dein Foto"-Button wäre doppelt.
      var vizModes = [
        { id:"farbe", label:"Farbe" },
        { id:"raum",  label:"Fotos" }
      ];
      var vizSegHtml = vizModes.map(function(m){
        var isAct = S.vizMode===m.id;
        return '<button class="ftk-v18__viz-seg-btn'+(isAct?" ftk-v18__viz-seg-btn--active":"")+'" data-v18="viz-seg" data-mode="'+esc(m.id)+'" type="button">'+esc(m.label)+'</button>';
      }).join("");

      // Harmonien
      var harmHtml = harmonics.slice(0,6).map(function(h){
        return '<button class="ftk-v18__harmony-btn" data-v18="harmony" data-id="'+esc(h.c.id)+'">' +
          '<span class="ftk-v18__harmony-color" style="background:'+esc(h.c.hex)+'"></span>' +
          '<span class="ftk-v18__harmony-meta">' +
            '<span class="ftk-v18__harmony-tag">'+esc(h.role)+'</span>' +
            '<span class="ftk-v18__harmony-code">'+esc(h.c.name||h.c.id)+'</span>' +
          '</span>' +
        '</button>';
      }).join("");

      return '<div class="ftk-v18__modal-overlay" data-v18="modal-overlay">' +
        '<div class="ftk-v18__modal-card" data-v18="modal-card" role="dialog" aria-modal="true" aria-label="Farbton-Details">' +
          // Header
          '<div class="ftk-v18__modal-header">' +
            '<span class="ftk-v18__modal-swatch" style="background:'+esc(c.hex)+'"></span>' +
            '<div style="min-width:0;">' +
              '<div class="ftk-v18__modal-code">'+esc(c.id)+'</div>' +
              '<div class="ftk-v18__modal-name">'+esc(prettyName(c.name))+' · '+esc(cardLabel(c.card||S.currentSlug))+'</div>' +
            '</div>' +
            '<button class="ftk-v18__modal-close" data-v18="modal-close">&times;</button>' +
          '</div>' +
          // Body
          '<div class="ftk-v18__modal-body">' +
            // LEFT
            '<div class="ftk-v18__modal-left">' +
              '<div class="ftk-v18__viz-seg ftk-v18__hide-scroll" role="group" aria-label="Ansicht">'+vizSegHtml+'</div>' +
              '<div class="ftk-v18__viz-preview">' +
                '<div class="ftk-v18__viz-color-block" style="background:'+esc(c.hex)+(S.vizMode!=="farbe"?';display:none':'')+'">' +
                  '<button class="ftk-v18__color-enlarge" data-v18="color-enlarge" type="button" aria-label="Farbton groß anzeigen">'+ENLARGE_SVG+'<span>Vergrößern</span></button>' +
                '</div>' +
                '<div class="ftk-v18__viz-wrap"'+(S.vizMode==="farbe"?' style="display:none"':'')+'></div>' +
              '</div>' +
              '<div class="ftk-v18__color-info">' +
                '<span><b>HEX</b> '+esc(c.hex.toUpperCase())+'</span>' +
                '<span><b>RGB</b> '+rgb.r+', '+rgb.g+', '+rgb.b+'</span>' +
                '<span><b>Familie</b> '+(FAMILY_LIST.find(function(f){return f.id===colorFamilyId(c);})||{label:"–"}).label+'</span>' +
              '</div>' +
              '<div class="ftk-v18__harmonies-heading">Passt gut dazu</div>' +
              '<div class="ftk-v18__harmonies">'+(harmHtml||'<span style="font-size:13px;color:#64748B">Lade Karte für Harmonien…</span>')+'</div>' +
              '<p class="ftk-v18__viz-disclaimer">Bildschirmdarstellung kann abweichen' + (musterUrl?' — <a href="'+esc(musterUrl)+'">Muster bestellen</a>':' — Originalfarbtonkarte empfohlen') + '</p>' +
            '</div>' +
            // RIGHT — PDP-Modus: nur DIESES Produkt + "Farbton übernehmen";
            // sonst (Standalone) der volle Produkt-Picker + Farbmengen-Rechner.
            (pdpMode ?
              '<div class="ftk-v18__modal-right ftk-v18__modal-right--pdp">' +
                '<div class="ftk-v18__pdp-commit">' +
                  '<div class="ftk-v18__pdp-commit-label">Gewählter Farbton</div>' +
                  '<div class="ftk-v18__pdp-commit-color">' +
                    '<span class="ftk-v18__pdp-commit-swatch" style="background:'+esc(c.hex)+'"></span>' +
                    '<div style="min-width:0">' +
                      '<div class="ftk-v18__pdp-commit-code">'+esc(c.id)+'</div>' +
                      '<div class="ftk-v18__pdp-commit-name">'+esc(prettyName(c.name))+'</div>' +
                    '</div>' +
                  '</div>' +
                  '<div class="ftk-v18__pdp-commit-tag">&#10003; In '+esc(pdpProduct&&pdpProduct.title?pdpProduct.title:"deinem Produkt")+' tönbar</div>' +
                  pdpCommitPriceHtml(c) +
                  '<button class="ftk-v18__btn-atc ftk-v18__btn-apply" data-v18="apply-color">Diesen Farbton übernehmen &#8594;</button>' +
                  '<div class="ftk-v18__pdp-commit-note">Übernimmt den Ton auf dieser Seite — Gebinde &amp; Menge wählst du danach. Exakt nach Sto gemischt.</div>' +
                '</div>' +
              '</div>'
            :
              '<div class="ftk-v18__modal-right">' +
                // Product card
                '<div class="ftk-v18__product-card">' +
                  '<div class="ftk-v18__product-card-heading"><span class="ftk-v18__step-badge">2</span><span class="ftk-v18__product-card-title">Produkt wählen</span></div>' +
                  '<div class="ftk-v18__area-pills">'+areaPillsHtml+'</div>' +
                  '<div class="ftk-v18__prod-search-wrap">' +
                    '<span class="ftk-v18__search-icon">&#128269;</span>' +
                    '<input type="search" class="ftk-v18__prod-search" data-v18="prod-search" placeholder="Produkt suchen…" value="'+esc(S.prodQuery)+'" aria-label="Produkt suchen (nur tönbare)" autocomplete="off" spellcheck="false">' +
                  '</div>' +
                  '<div class="ftk-v18__product-list">'+prodsHtml+'</div>' +
                  '<div class="ftk-v18__variant-label">Gebinde</div>' +
                  '<div class="ftk-v18__variant-chips">'+gebHtml+'</div>' +
                  '<div class="ftk-v18__price-atc-row">' +
                    '<div>' +
                      '<div class="ftk-v18__price-label-sub">in '+esc(c.id)+'</div>' +
                      '<div class="ftk-v18__price-label" data-v18="price-label">'+esc(priceLabel)+'</div>' +
                    '</div>' +
                    '<button class="ftk-v18__btn-atc" data-v18="open-product">Produkt öffnen &#8594;</button>' +
                  '</div>' +
                '</div>' +
                // Calc
                '<div class="ftk-v18__calc-card">' +
                  '<div class="ftk-v18__calc-heading"><span class="ftk-v18__calc-icon">&#129518;</span><span class="ftk-v18__calc-title">Farbmengen-Rechner</span></div>' +
                  '<div class="ftk-v18__calc-sub">Wie viel brauchst du? Wir rechnen Liter & Gebinde aus.</div>' +
                  '<div class="ftk-v18__calc-area-row"><span class="ftk-v18__calc-area-label">Wandfläche</span><span class="ftk-v18__calc-area-value" data-v18="calc-area-val">'+S.calcArea+' m²</span></div>' +
                  '<input type="range" min="5" max="150" step="1" value="'+S.calcArea+'" data-v18="calc-area-range">' +
                  '<div class="ftk-v18__calc-coats-label">Anstriche</div>' +
                  '<div class="ftk-v18__calc-coats-chips">'+coatsHtml+'</div>' +
                  '<div class="ftk-v18__calc-result">' +
                    '<div class="ftk-v18__calc-result-row"><span class="ftk-v18__calc-result-label">Verbrauch</span><span class="ftk-v18__calc-result-val" data-v18="calc-verbrauch">'+esc(verbrauchLabel(selProd))+'</span></div>' +
                    '<div class="ftk-v18__calc-result-row" style="margin-top:8px"><span class="ftk-v18__calc-result-label">Du brauchst ca.</span><span class="ftk-v18__calc-result-val" data-v18="calc-liters">'+esc(calcLiters)+'</span></div>' +
                    '<div class="ftk-v18__calc-result-row" style="margin-top:8px"><span class="ftk-v18__calc-result-label">Empfehlung</span><span class="ftk-v18__calc-recommend-val" data-v18="calc-recommend">'+esc(recommend)+'</span></div>' +
                    '<div class="ftk-v18__calc-total-row"><span class="ftk-v18__calc-result-label">≈ Gesamt</span><span class="ftk-v18__calc-total-val" data-v18="calc-cost">'+esc(calcCost)+'</span></div>' +
                  '</div>' +
                '</div>' +
              '</div>'
            ) +
          '</div>' +
        '</div>' +
      '</div>';
    }

    // Verbrauch (l/m² pro Anstrich) des Produkts; Fallback = generische Ergiebigkeit.
    function productVerbrauch(prod) {
      return (prod && typeof prod.verbrauch === "number" && prod.verbrauch > 0) ? prod.verbrauch : (1/ERGIEBIGKEIT);
    }
    function calcLitersRaw(prod) {
      return S.calcArea * S.calcCoats * productVerbrauch(prod);
    }
    function verbrauchLabel(prod) {
      var unit = (prod && prod.unit === "kg") ? "kg" : "L";
      return productVerbrauch(prod).toFixed(2).replace(".",",") + " " + unit + "/m² pro Anstrich";
    }

    function updateCalcDisplay() {
      var slot = q(".ftk-v18__modal-slot");
      if (!slot) return;
      var selProd = S.products[S.prodIdx]||null;
      var litersRaw = calcLitersRaw(selProd);
      var el_l = slot.querySelector('[data-v18="calc-liters"]');
      var el_r = slot.querySelector('[data-v18="calc-recommend"]');
      var el_c = slot.querySelector('[data-v18="calc-cost"]');
      var el_av = slot.querySelector('[data-v18="calc-area-val"]');
      var el_v = slot.querySelector('[data-v18="calc-verbrauch"]');
      if (el_l) el_l.textContent = litersRaw.toFixed(1)+" L";
      if (el_r) el_r.textContent = buildGebindeRecommend(litersRaw);
      if (el_c) el_c.textContent = selProd ? estimateCost(selProd, litersRaw) : "–";
      if (el_av) el_av.textContent = S.calcArea+" m²";
      if (el_v) el_v.textContent = verbrauchLabel(selProd);
    }

    // Preis + "Produkt öffnen"-Button nach Produkt-/Suchwechsel angleichen.
    // (Es werden nur machbare Produkte gelistet → kein MABA-Block mehr nötig.)
    function updateAtcState() {
      var slot = q(".ftk-v18__modal-slot");
      if (!slot) return;
      var selProd = S.products[S.prodIdx]||null;
      var price= slot.querySelector('[data-v18="price-label"]');
      if (price) price.textContent = selProd ? (selProd.price||"–") : "–";
      var btn = slot.querySelector('[data-v18="open-product"]');
      if (btn) btn.disabled = !selProd;   // leere Suche → kein Produkt → deaktiviert
    }

    function buildGebindeRecommend(liters) {
      // Greedy von groß→klein
      var sizes = GEBINDE_SIZES.slice().sort(function(a,b){return b-a;});
      var remaining = liters;
      var result = [];
      sizes.forEach(function(s){
        if (remaining<=0) return;
        var count = Math.floor(remaining/s);
        if (count>0) { result.push(count+"×"+s+" L"); remaining-=count*s; }
      });
      if (remaining>0) result.push("1×"+GEBINDE_SIZES[0]+" L");
      return result.join(" + ")||"–";
    }

    function estimateCost(prod, liters) {
      // Grobe Schätzung: wenn Preis "ab X,XX €/Liter" → liters * pricePerL
      // Alternativ: Einzel-Gebindepreis aus prod.price hochrechnen
      // prod.price = "X,XX € / Liter" oder "ab XX,XX €"
      var priceStr = String(prod.price||"").replace(/[^\d,\.]/g,"").replace(",",".");
      var priceNum = parseFloat(priceStr)||0;
      if (!priceNum) return "–";
      // Heuristik: wenn Preis < 5 → pro Liter, sonst pro Gebinde (5L Approx)
      var total = priceNum < 5 ? priceNum*liters : priceNum*(liters/5);
      return "≈ "+fmtEur(Math.round(total*10)/10);
    }

    // ============================================================
    // FAVORITES DRAWER
    // ============================================================
    function openFavDrawer() {
      S.favOpen = true;
      renderFavDrawer();
      document.body.style.overflow = "hidden";
    }

    function closeFavDrawer() {
      S.favOpen = false;
      var slot = q(".ftk-v18__fav-slot");
      if (slot) slot.innerHTML = "";
      releaseBodyScroll();
    }

    function renderFavDrawer() {
      var slot = q(".ftk-v18__fav-slot");
      if (!slot) return;
      var listHtml = "";
      if (S.favs.length) {
        S.favs.forEach(function(f) {
          listHtml += '<div class="ftk-v18__fav-item">' +
            '<button class="ftk-v18__fav-item-swatch" style="background:'+esc(f.h)+'" data-v18="fav-open-color" data-id="'+esc(f.id)+'"></button>' +
            '<button class="ftk-v18__fav-item-info" data-v18="fav-open-color" data-id="'+esc(f.id)+'">' +
              '<span class="ftk-v18__fav-item-code">'+esc(f.id)+'</span>' +
              '<span class="ftk-v18__fav-item-name">'+esc(f.n||"")+'</span>' +
            '</button>' +
            '<button class="ftk-v18__fav-item-remove" data-v18="fav-remove" data-id="'+esc(f.id)+'">&times;</button>' +
          '</div>';
        });
      }
      slot.innerHTML =
        '<div class="ftk-v18__fav-overlay" data-v18="fav-overlay">' +
          '<div class="ftk-v18__fav-drawer" data-v18="fav-drawer">' +
            '<div class="ftk-v18__fav-header">' +
              '<span class="ftk-v18__fav-heart-icon">&#9829;</span>' +
              '<span class="ftk-v18__fav-title">Meine Merkliste</span>' +
              '<span class="ftk-v18__fav-count-chip">'+S.favs.length+'</span>' +
              '<button class="ftk-v18__fav-close" data-v18="fav-close">&times;</button>' +
            '</div>' +
            '<div class="ftk-v18__fav-body">' +
              (!S.favs.length ?
                '<div class="ftk-v18__fav-empty">' +
                  '<div class="ftk-v18__fav-empty-icon">&#9825;</div>' +
                  '<div class="ftk-v18__fav-empty-title">Noch nichts gemerkt</div>' +
                  '<div class="ftk-v18__fav-empty-sub">Tippe auf das Herz bei einem Farbton, um ihn hier zu sammeln.</div>' +
                '</div>' : "") +
              '<div class="ftk-v18__fav-list">'+listHtml+'</div>' +
            '</div>' +
            (S.favs.length ?
              '<div class="ftk-v18__fav-footer">' +
                '<button class="ftk-v18__btn-fav-consult" data-v18="contact">Beratung zu meiner Auswahl</button>' +
              '</div>' : "") +
          '</div>' +
        '</div>';
      attachFavEvents();
    }

    // ============================================================
    // TOAST
    // ============================================================
    function showToast(msg, type) {
      var slot = q(".ftk-v18__toast-slot");
      if (!slot) return;
      var cls = "ftk-v18__toast" + (type==="success"?" ftk-v18__toast--success":type==="error"?" ftk-v18__toast--error":"");
      slot.innerHTML = '<div class="'+cls+'">'+esc(msg)+'</div>';
      setTimeout(function(){ slot.innerHTML=""; }, 3000);
    }

    // ============================================================
    // EVENT ATTACHMENT
    // ============================================================
    var _searchTimer = null;
    var _brightTimer = null;

    function attachEvents() {
      rootEl.addEventListener("click", handleClick);
      rootEl.addEventListener("input", handleInput);
      rootEl.addEventListener("change", handleChange);
      rootEl.addEventListener("pointerdown", handlePointerDown);
      document.addEventListener("keydown", handleKeydown);
    }

    function attachModalEvents() {
      // nichts extra — events laufen über rootEl Delegation
    }

    // Fehler 3: Sticky-Offset = Höhe der app-eigenen Sticky-Kopfzeile, damit der
    // sticky Suchbereich exakt darunter andockt (kein Hardcode, reagiert auf Resize).
    var _stickyResizeHandler = null;
    function setupStickyOffset() {
      // Kein eigener Sticky-Header/-Bar mehr → fester Offset-Fallback für
      // scroll-margin-top der Ergebnisse.
      rootEl.style.setProperty("--ftk18-header-h", "64px");
    }

    // Mobile-Sticky-Suchleiste: erscheint beim Scrollen (sobald das Hauptsuchfeld
    // oben raus ist) und sitzt bündig unter dem (ggf. ein-/ausblendenden) Theme-Header.
    var _mobSearchStop = null;
    function setupMobSearch() {
      var bar = rootEl.querySelector('[data-v18="mobsearch"]');
      var anchor = rootEl.querySelector(".ftk-v18__search-input-wrap") || rootEl.querySelector(".ftk-v18__search-card");
      if (!bar || !anchor) return;
      bar.inert = true;
      var themeHeader = document.querySelector("sticky-header") ||
                        document.querySelector(".section-header") ||
                        document.querySelector(".shopify-section-group-header-group");
      var raf = window.requestAnimationFrame ? window.requestAnimationFrame.bind(window) : function(f){ return setTimeout(f,16); };
      var caf = window.cancelAnimationFrame ? window.cancelAnimationFrame.bind(window) : clearTimeout;
      var vis=false, rafId=null, lastTop=-1;
      // Kein Dauer-rAF mehr (Review-Befund: getBoundingClientRect pro Frame
      // auch ohne Scroll) — Messung nur noch scroll-/resize-getrieben,
      // rAF-gedrosselt auf max. 1 Messung pro Frame.
      function measure(){
        rafId=null;
        if(!vis) return;
        var top=0;
        if(themeHeader){ var r=themeHeader.getBoundingClientRect(); top=Math.max(0,Math.round(r.bottom)); }
        if(top!==lastTop){ lastTop=top; bar.style.top=top+"px"; }
      }
      function requestMeasure(){ if(vis && rafId==null) rafId=raf(measure); }
      function setVisible(v){
        if(v===vis) return; vis=v;
        bar.classList.toggle("ftk-v18__mobsearch--visible", v);
        bar.inert=!v;
        if(v){
          requestMeasure();
          window.addEventListener("scroll", requestMeasure, { passive:true });
          window.addEventListener("resize", requestMeasure);
        } else {
          window.removeEventListener("scroll", requestMeasure);
          window.removeEventListener("resize", requestMeasure);
          if(rafId){ caf(rafId); rafId=null; }
        }
      }
      _mobSearchStop=function(){
        window.removeEventListener("scroll", requestMeasure);
        window.removeEventListener("resize", requestMeasure);
        if(rafId){ caf(rafId); rafId=null; }
      };
      if(typeof IntersectionObserver==="undefined"){ return; }
      var io=new IntersectionObserver(function(entries){
        entries.forEach(function(e){ setVisible(!e.isIntersecting && e.boundingClientRect.top<0); });
      },{ threshold:0 });
      io.observe(anchor);
    }

    function attachFavEvents() {
      // nichts extra
    }

    function handleKeydown(e) {
      if (e.key==="Escape") {
        // Reihenfolge = visuelle Stapelung (oberstes zuerst schließen):
        // Lightbox (z90) → Favoriten (z70) → Karten-Dropdown/Modal (z60).
        if (S.colorLightboxOpen) { closeColorLightbox(); return; }
        if (S.favOpen) { closeFavDrawer(); return; }
        if (S.cardDropdownOpen) { closeCardDropdown(); return; }
        if (S.sel) { closeModal(); return; }
      }
      // Karten-Dropdown-Trigger (role=button) per Tastatur öffnen/schließen
      var t = e.target;
      if (t && t.getAttribute && t.getAttribute("data-v18")==="cardchooser-toggle" &&
          (e.key==="Enter" || e.key===" " || e.key==="Spacebar")) {
        e.preventDefault();
        if (S.cardDropdownOpen) closeCardDropdown(); else openCardDropdown();
      }
    }

    function handleClick(e) {
      var t = e.target;
      var btn = t.closest("[data-v18]");

      // Karten-Dropdown: Klick außerhalb (und nicht auf Toggle/Option/Suche) schließt.
      if (S.cardDropdownOpen) {
        var inChooser = t.closest(".ftk-v18__cardchooser");
        if (!inChooser) closeCardDropdown();
      }

      if (!btn) return;
      var action = btn.getAttribute("data-v18");

      switch(action) {
        case "tab":
          setEntry(btn.getAttribute("data-tab"));
          break;
        case "search-clear":
          S.query="";
          S._scrolledToResults=false;
          cancelGlobalSearch();
          qa('[data-v18="search-input"]').forEach(function(inp){ inp.value=""; });
          qa('[data-v18="search-clear"]').forEach(function(c){ c.style.display="none"; });
          // das Suchfeld NEBEN dem geklickten Clear-Button fokussieren (nicht ein
          // evtl. off-screen Feld) → kein Seiten-Sprung.
          var clearWrap=btn.closest(".ftk-v18__search-input-wrap, .ftk-v18__mobsearch-inner");
          var inp=clearWrap?clearWrap.querySelector('[data-v18="search-input"]'):q('[data-v18="search-input"]');
          if(inp) inp.focus();
          renderGrid();
          break;
        case "cardpill":
          switchCard(btn.getAttribute("data-slug"));
          break;
        case "cardchooser-toggle":
          if (S.cardDropdownOpen) closeCardDropdown(); else openCardDropdown();
          break;
        case "cardchooser-opt":
          switchCard(btn.getAttribute("data-slug"));
          break;
        case "family-chip":
          var fam=btn.getAttribute("data-family");
          S.family=fam;
          S.displayedCount=GRID_PAGE_SIZE;
          qa(".ftk-v18__family-chip").forEach(function(el){
            el.classList.toggle("ftk-v18__family-chip--active", el.getAttribute("data-family")===fam);
          });
          renderGrid();
          break;
        case "tile":
          var colorId=btn.getAttribute("data-id");
          var color=findColorById(colorId);
          if(color) openModal(color);
          break;
        case "tile-fav":
          e.stopPropagation();
          var fid=btn.getAttribute("data-id");
          var fc=findColorById(fid)||{id:fid,name:btn.getAttribute("data-name"),hex:btn.getAttribute("data-hex"),card:S.currentSlug};
          var wasFav=isFav(fid);
          toggleFav(fc);
          btn.classList.toggle("ftk-v18__tile-heart--active", isFav(fid));
          updateFavBadge();
          if(!wasFav&&isFav(fid)) trackFTK("ftk_fav_add", { color_id: fid, hex: fc.hex });
          break;
        case "reset-filters":
          S.query=""; S.family="alle"; S.helFilter=null; S.displayedCount=GRID_PAGE_SIZE;
          S.brightness=50; S.brightnessActive=false;
          S.pcFilter={ "01":true, "02":true, "03":true, "04":true };
          var si=q('[data-v18="search-input"]'); if(si) si.value="";
          var bs2=q('[data-v18="bright-slider"]'); if(bs2) bs2.value=50;
          var bh2=q('[data-v18="bright-hint"]'); if(bh2) bh2.textContent="alle";
          var br2=q('[data-v18="bright-reset"]'); if(br2) br2.style.display="none";
          qa(".ftk-v18__pc-chip").forEach(function(el){ el.classList.add("ftk-v18__pc-chip--active"); el.setAttribute("aria-pressed","true"); });
          qa(".ftk-v18__family-chip").forEach(function(el){ el.classList.toggle("ftk-v18__family-chip--active", el.getAttribute("data-family")==="alle"); });
          renderGrid();
          break;
        case "load-more":
          appendMoreTiles();
          break;
        case "retry-card":
          loadCard(btn.getAttribute("data-slug") || S.currentSlug || defaultCard);
          break;
        case "cardsearch-as-tone":
          // Aus dem leeren Kollektions-Dropdown direkt in die Ton-Suche wechseln
          var tq = btn.getAttribute("data-q") || "";
          closeCardDropdown();
          if (tq) {
            S.query = tq;
            qa('[data-v18="search-input"]').forEach(function(inp){ inp.value = tq; });
            qa('[data-v18="search-clear"]').forEach(function(c){ c.style.display = ""; });
            try { triggerGlobalSearch(tq); } catch(e){}
            renderGrid();
          }
          break;
        case "grid-size":
          applyGridSize(btn.getAttribute("data-size"));
          break;
        case "pc-chip":
          var pc=btn.getAttribute("data-pc");
          S.pcFilter[pc] = !(S.pcFilter[pc]!==false); // toggle (default true)
          btn.classList.toggle("ftk-v18__pc-chip--active", S.pcFilter[pc]!==false);
          btn.setAttribute("aria-pressed", S.pcFilter[pc]!==false?"true":"false");
          S.displayedCount=GRID_PAGE_SIZE;
          renderGrid();
          break;
        case "pc-info":
          var tip=q('[data-v18="pc-tooltip"]');
          if(tip) tip.classList.toggle("ftk-v18__pc-tooltip--show");
          break;
        case "bright-reset":
          S.brightness=50; S.brightnessActive=false;
          var bs=q('[data-v18="bright-slider"]'); if(bs) bs.value=50;
          var bh=q('[data-v18="bright-hint"]'); if(bh) bh.textContent="alle";
          btn.style.display="none";
          S.displayedCount=GRID_PAGE_SIZE;
          renderGrid();
          break;
        case "open-fav":
          openFavDrawer();
          break;
        case "fav-close":
          closeFavDrawer();
          break;
        case "fav-overlay":
          if(e.target===btn) closeFavDrawer();
          break;
        case "fav-remove":
          var rid=btn.getAttribute("data-id");
          S.favs=S.favs.filter(function(f){return f.id!==rid;});
          saveFavs();
          updateFavBadge();
          renderFavDrawer();
          break;
        case "fav-open-color":
          var oid=btn.getAttribute("data-id");
          var oc=S.colors.find(function(c){return c.id===oid;});
          if(oc){ closeFavDrawer(); openModal(oc); break; }
          // Favorit stammt aus einer ANDEREN Karte (Review-Befund: Klick tat
          // nichts): Ton aus den gespeicherten Favoriten-Daten rekonstruieren —
          // openModal lädt priceClass/toneClass über den Cross-Card-Pfad nach.
          var fv=(S.favs||[]).find(function(f){return f.id===oid;});
          if(fv){ closeFavDrawer(); openModal({ id: fv.id, name: fv.n || fv.id, hex: fv.h || "#888888", card: fv.cs || fv.card || "", _global: true }); }
          break;
        case "modal-overlay":
          if(e.target===btn) closeModal();
          break;
        case "modal-close":
          closeModal();
          break;
        case "color-enlarge":
          if(S.sel) openColorLightbox(S.sel);
          break;
        case "clightbox-overlay":
          if(e.target===btn) closeColorLightbox();
          break;
        case "clightbox-close":
          closeColorLightbox();
          break;
        case "modal-card":
          // stop propagation via overlay check
          break;
        case "viz-seg":
          handleVizMode(btn.getAttribute("data-mode"));
          break;
        case "harmony":
          var hid=btn.getAttribute("data-id");
          var hc=S.colors.find(function(c){return c.id===hid;});
          if(hc){ closeModal(); openModal(hc); }
          break;
        case "area-pill":
          S.area=btn.getAttribute("data-area");
          S.prodIdx=0;
          S.prodQuery="";
          loadProducts();
          renderModal();
          // Visualizer-Modus beibehalten: war "Im Raum"/"Dein Foto" aktiv,
          // mit neuer Default-Szene erneut mounten.
          if (S.vizMode!=="farbe") handleVizMode(S.vizMode);
          break;
        case "prod-item":
          S.prodIdx=parseInt(btn.getAttribute("data-idx")||"0",10);
          rerenderProductList();
          break;
        case "gebinde-chip":
          S.gebindeLabel=btn.getAttribute("data-lbl");
          qa(".ftk-v18__variant-chips [data-v18='gebinde-chip']").forEach(function(el){
            el.classList.toggle("ftk-v18__variant-chip--active", el.getAttribute("data-lbl")===S.gebindeLabel);
          });
          updateCalcDisplay();
          break;
        case "coats-chip":
          S.calcCoats=parseInt(btn.getAttribute("data-coats")||"2",10);
          qa('[data-v18="coats-chip"]').forEach(function(el){
            el.classList.toggle("ftk-v18__variant-chip--active", parseInt(el.getAttribute("data-coats"),10)===S.calcCoats);
          });
          updateCalcDisplay();
          break;
        case "open-product":
          doOpenProduct(btn);
          break;
        case "apply-color":
          // PDP-Modus: gewählten Ton an die PDP zurückgeben (statt Produkt zu öffnen).
          if (S.sel && onApply) {
            var rgbA = hexToRgb(S.sel.hex);
            // toneClass/priceClass robust auflösen: globale Suchtreffer tragen
            // KEIN tc/pc (Worker liefert nur i/n/h/c) → über die in openModal
            // nachgeladene Karte (getColorById) holen, sonst aus S.sel.
            var fullA = null;
            try { fullA = global.FTK.getColorById && global.FTK.getColorById(S.sel.id); } catch(e) {}
            var tcA = (fullA && fullA.toneClass != null && fullA.toneClass !== "") ? String(fullA.toneClass)
                    : String(S.sel.toneClass != null ? S.sel.toneClass : "");
            // Fertig-Weiß (nur AW11/AW15/RAL9010/RAL9016/NS01213) → weiss:true,
            // Weiß-Variante/Weiß-Preis. Alle ANDEREN Klasse-0-Weißtöne sind PC1
            // (Regel 2026-07-09 — vorher gingen alle tc-0-Töne fälschlich auf
            // die weiß-Variante: Sto lieferte Weiß, Preis zu niedrig).
            var isWhiteTone = isFertigWeiss(S.sel.id);
            var pcA = "";
            if (!isWhiteTone) {
              try {
                var pcRaw = (fullA && fullA.priceClass) || S.sel.priceClass ||
                            (global.FTK.normalizePriceClass ? global.FTK.normalizePriceClass(tcA) : "");
                pcA = pcRaw ? String(parseInt(pcRaw, 10) || "") : "";
              } catch(e) {}
              if (!pcA && tcA === "0") pcA = "1"; // Klasse-0-Weißton ohne Fertig-Weiß → PC1
            }
            var bezA = prettyName(S.sel.name) || S.sel.id;
            // WICHTIG (Sto-Bestellung): Property "Farbe" = Farbton-CODE (id, z.B. ALF0540),
            // nur als Backup der Name. "Bez" bleibt der Name. (Bug seit V18: hier stand
            // der Name in beiden → Sto bekam "Anthrazit 4" statt "ALF0540".)
            onApply({
              bez: bezA, color: S.sel.id || bezA,
              rgb: rgbA.r + "," + rgbA.g + "," + rgbA.b,
              // Unbekannte Preisstufe (tc=99, ungeladene Karte): NIE klasse ''
              // senden (griffe in den Legacy-getönt-Fallback = still PC1) —
              // '99' läuft auf der PDP in den Verwerfen-Pfad mit Hinweis.
              klasse: isWhiteTone ? "" : (pcA || "99"),
              weiss: isWhiteTone, hex: S.sel.hex, id: S.sel.id, variantId: ""
            });
            trackFTK("ftk_apply_to_pdp", { color_id: S.sel.id, hex: S.sel.hex, klasse: pcA, weiss: isWhiteTone });
            closeModal();
          }
          break;
        case "modal-fav":
          if(!S.sel) break;
          toggleFav(S.sel);
          var isFavNow=isFav(S.sel.id);
          btn.classList.toggle("ftk-v18__btn-fav-sel--active", isFavNow);
          btn.innerHTML = isFavNow ? '&#9829; Gemerkt' : '&#9825; Merken';
          updateFavBadge();
          // Kachel-Herz aktualisieren
          var tileHeart=q('.ftk-v18__tile-heart[data-id="'+S.sel.id+'"]');
          if(tileHeart) tileHeart.classList.toggle("ftk-v18__tile-heart--active",isFavNow);
          if(isFavNow) trackFTK("ftk_fav_add", { color_id: S.sel.id, hex: S.sel.hex });
          break;
        case "sample":
          if(musterUrl&&S.sel) window.location.href=musterUrl+"?color="+encodeURIComponent(S.sel.id);
          break;
        case "contact":
          // Dasselbe Beratungs-/Kontakt-Popup wie das "Kontakt" im Header
          // (global openBeratungPopup); Fallback Telefon, falls nicht geladen.
          if (typeof global.openBeratungPopup === "function") { global.openBeratungPopup(); }
          else { window.location.href = "tel:+4921619881100"; }
          break;
        case "choose-wheel":
          var wHex=hslToHex(S.wheelH,S.wheelS,S.wheelL);
          var nearest=S.colors.length?nearestColor(wHex,S.colors):null;
          if(nearest){ openModal(nearest); }
          break;
        case "mood-swatch":
          var mHex=btn.getAttribute("data-hex");
          var mc=S.colors.length?nearestColor(mHex,S.colors):null;
          if(mc){ openModal(mc); }
          break;
        case "guided-chip":
          var key=btn.getAttribute("data-key");
          var val=btn.getAttribute("data-val");
          S["g"+key] = (S["g"+key]===val)?null:val;
          btn.parentElement.querySelectorAll('[data-v18="guided-chip"]').forEach(function(el){
            el.classList.toggle("ftk-v18__guided-chip--active", el.getAttribute("data-val")===S["g"+key]);
          });
          break;
        case "guided-apply":
          applyGuided();
          break;
      }
    }

    function handleInput(e) {
      var t = e.target;
      var v18 = t.getAttribute("data-v18");
      if (v18==="search-input") {
        clearTimeout(_searchTimer);
        S.query=t.value;
        // Zwei Suchfelder (Haupt-Kasten + Sticky-Bar) synchron halten
        qa('[data-v18="search-input"]').forEach(function(inp){ if(inp!==t) inp.value=S.query; });
        qa('[data-v18="search-clear"]').forEach(function(clr){ clr.style.display=S.query?"":"none"; });
        _searchTimer=setTimeout(function(){
          S.displayedCount=GRID_PAGE_SIZE;
          if (S.query && S.query.trim().length>=2) {
            // Lokale Treffer sofort, kartenübergreifende Treffer nachladen
            S.globalMode=false; S.globalResults=[];
            renderGrid();
            triggerGlobalSearch(S.query);
            trackFTK("ftk_search_used", { query: S.query, card: S.currentSlug });
            // Mobile: direkt zum Ergebnis scrollen (einmal pro Such-Session) —
            // die Mobile-Suchleiste bleibt dabei oben fixiert.
            if (!S._scrolledToResults && window.matchMedia && window.matchMedia("(max-width:860px)").matches) {
              S._scrolledToResults = true;
              var rs = q(".ftk-v18__results-section");
              if (rs) rs.scrollIntoView({ behavior:"smooth", block:"start" });
            }
          } else {
            cancelGlobalSearch();
            renderGrid();
            S._scrolledToResults = false;
          }
        }, SEARCH_DEBOUNCE);
      }
      if (v18==="cardchooser-search") {
        renderCardDropdownList(t.value);
      }
      if (v18==="prod-search") {
        // Produkt im Modal suchen (nur machbare Produkte des Bereichs)
        S.prodQuery=t.value;
        S.prodIdx=0;
        S.products=curateProducts(S.productPool, S.area);
        rerenderProductList();
        updateAtcState();
      }
      if (v18==="wheel-l") {
        S.wheelL=parseInt(t.value,10);
        rerenderWheelNearest();
      }
      if (v18==="calc-area-range") {
        S.calcArea=parseInt(t.value,10);
        updateCalcDisplay();
      }
      if (v18==="bright-slider") {
        S.brightness=parseInt(t.value,10);
        S.brightnessActive = (S.brightness<=40 || S.brightness>=60);
        var bh=q('[data-v18="bright-hint"]');
        if(bh) bh.textContent = S.brightnessActive ? (S.brightness<50?"dunkler":"heller") : "alle";
        var br=q('[data-v18="bright-reset"]');
        if(br) br.style.display = S.brightnessActive?"":"none";
        clearTimeout(_brightTimer);
        _brightTimer=setTimeout(function(){
          S.displayedCount=GRID_PAGE_SIZE;
          renderGrid();
        }, 120);
      }
    }

    // P4 (a): Kachelgröße anwenden + persistieren
    function applyGridSize(size) {
      if (["mini","normal","large"].indexOf(size)<0) size="normal";
      S.gridSize=size;
      try { localStorage.setItem(GRIDSIZE_KEY, size); } catch(e) {}
      var grid=q('[data-v18="swatch-grid"]');
      if(grid){
        grid.classList.remove("ftk-v18__swatch-grid--mini","ftk-v18__swatch-grid--normal","ftk-v18__swatch-grid--large");
        grid.classList.add("ftk-v18__swatch-grid--"+size);
      }
      qa(".ftk-v18__gridsize-btn").forEach(function(b){
        var on=b.getAttribute("data-size")===size;
        b.classList.toggle("ftk-v18__gridsize-btn--active", on);
        b.setAttribute("aria-pressed", on?"true":"false");
      });
    }

    function handleChange(e) {
      // Foto-Upload + Tönung übernimmt jetzt das FTKVisualizer-Modul intern.
    }

    // Farbrad Drag
    function handlePointerDown(e) {
      var wheel=e.target.closest(".ftk-v18__wheel");
      if(!wheel) return;
      S.wheelDrag=true;
      updateWheelFromPointer(e,wheel);
      var onMove=function(ev){ if(!S.wheelDrag) return; ev.preventDefault(); updateWheelFromPointer(ev,wheel); };
      var onUp=function(){ S.wheelDrag=false; window.removeEventListener("pointermove",onMove); window.removeEventListener("pointerup",onUp); };
      window.addEventListener("pointermove",onMove,{passive:false});
      window.addEventListener("pointerup",onUp);
    }

    function updateWheelFromPointer(e,wheel) {
      var rect=wheel.getBoundingClientRect();
      var cx=rect.left+rect.width/2;
      var cy=rect.top+rect.height/2;
      var dx=e.clientX-cx;
      var dy=e.clientY-cy;
      var angle=(Math.atan2(dy,dx)*(180/Math.PI)+90+360)%360;
      var dist=Math.sqrt(dx*dx+dy*dy);
      var r=Math.min(dist/(rect.width/2),1);
      S.wheelH=Math.round(angle);
      S.wheelS=Math.round(r*100);
      rerenderWheelNearest();
    }

    function setEntry(entry) {
      S.entry=entry;
      // Umschalter-Segmente aktiv schalten + aria. (Suche bleibt dauerhaft sichtbar.)
      qa(".ftk-v18__tool-seg").forEach(function(el){
        var m = el.getAttribute("data-tab")===entry;
        el.classList.toggle("ftk-v18__tool-seg--active", m);
        el.setAttribute("aria-pressed", m?"true":"false");
      });
      // Toggelt nur die 3 Tool-Panels (Such-Panel hat kein data-v18-panel mehr).
      qa(".ftk-v18__panel").forEach(function(el){
        el.classList.toggle("ftk-v18__panel--active",el.getAttribute("data-v18-panel")===entry);
      });
      // #3: Beim Wechsel auf den Farbkreis Szenen-Vorschau (nach)mounten.
      if (entry==="farbkreis") tryMountWheelViz();
    }

    function rerenderProductList() {
      var slot=q(".ftk-v18__modal-slot");
      if(!slot) return;
      var list=slot.querySelector(".ftk-v18__product-list");
      if(!list) return;
      var prods=S.products;
      if(!prods.length) {
        var emptyMsg = S.prodQuery
          ? 'Kein tönbares Produkt für „'+esc(S.prodQuery)+'". Suche leeren oder Bereich (Innen/Fassade/Lack) wechseln.'
          : (S.productsLoaded ? 'Für diesen Farbton ist in diesem Bereich kein Produkt tönbar. Wähle einen anderen Bereich (Innen/Fassade/Lack).'
             : (S.productsFailed ? 'Die Produkte konnten gerade nicht geladen werden — lade die Seite bitte einmal neu.' : 'Produkte werden geladen…'));
        list.innerHTML='<div class="ftk-v18__product-empty">'+emptyMsg+'</div>';
        updateAtcState();
        return;
      }
      var html="";
      prods.forEach(function(p,i){
        var isAct=i===S.prodIdx;
        html+='<button class="ftk-v18__product-item'+(isAct?" ftk-v18__product-item--active":"")+'" data-v18="prod-item" data-idx="'+i+'">' +
          '<span class="ftk-v18__product-radio"></span>' +
          '<span style="text-align:left;line-height:1.25;flex:1;">' +
            '<span class="ftk-v18__product-name">'+esc(p.title)+(p.isTopPick?'<span class="ftk-v18__product-top-pick">TOP</span>':'')+'</span>' +
            '<span class="ftk-v18__product-sub">'+esc(p.description?p.description.slice(0,60):p._cat||"")+'</span>' +
          '</span>' +
          '<span class="ftk-v18__product-price-from">'+esc(p.price||"")+'</span>' +
        '</button>';
      });
      list.innerHTML=html;
      updateCalcDisplay();
      updateAtcState();
    }

    function applyGuided() {
      // Helligkeits-Filter setzen
      var hell=S.gHell;
      if(hell==="Hell") S.helFilter="hell";
      else if(hell==="Mittel") S.helFilter="mittel";
      else if(hell==="Dunkel") S.helFilter="dunkel";
      else S.helFilter=null;

      // Familien-Guess aus gStimmung
      var stimmFamMap = {
        "Frisch & Hell":   "weiss",
        "Ruhig & Natürlich":"gruen",
        "Erdig & Warm":    "beige",
        "Kräftig & Mutig": null,
        "Warm & Gemütlich":"beige"
      };
      var famGuess=stimmFamMap[S.gStimmung||""]||null;
      if(famGuess) S.family=famGuess;

      S.displayedCount=GRID_PAGE_SIZE;
      renderGrid();
      // Suche ist permanent links sichtbar — kein Panelwechsel; stattdessen
      // zum Ergebnis-Grid scrollen, damit der Effekt sichtbar wird.
      var rs=q(".ftk-v18__results-section");
      if(rs) rs.scrollIntoView({behavior:"smooth",block:"start"});
    }

    // ============================================================
    // PRODUKT ÖFFNEN — zur PDP mit vorgewähltem Farbton (+ Gebinde-Variante)
    // ============================================================
    function doOpenProduct(triggerBtn) {
      var selProd = S.products[S.prodIdx]||null;
      if(!S.sel || !selProd || !selProd.url) {
        showToast("Kein Produkt gewählt.", "error");
        return;
      }
      // selProd.url enthält bereits die Farbton-Parameter (color/rgb/bez/klasse[/weiss]).
      var url = selProd.url;
      var handle = selProd.handle || (url.match(/\/products\/([^?#\/]+)/)||[])[1] || "";
      // Fertig-Weiß (nur die 5 Töne, Regel 2026-07-09): weiss=1 steckt in der
      // Bridge-URL, KEINE PC-Variante anhängen — sonst würde variantId-first
      // die weiß-Variante übersteuern. Alle anderen Klasse-0-Töne laufen als PC1.
      var fullO = null; try { fullO = global.FTK.getColorById && global.FTK.getColorById(S.sel.id); } catch(e){}
      var tcO = (fullO && fullO.toneClass != null && fullO.toneClass !== "") ? String(fullO.toneClass) : String(S.sel.toneClass != null ? S.sel.toneClass : "");
      var isWhite = isFertigWeiss(S.sel.id);
      var pcNum = S.sel.priceClass ? String(S.sel.priceClass).replace(/^0/,"")
                : (tcO === "0" && !isWhite ? "1" : null);

      if (triggerBtn) { triggerBtn.disabled=true; triggerBtn.textContent="Öffne …"; }
      trackFTK("ftk_open_product", { color_id: S.sel.id, handle: handle, pc: pcNum, weiss: isWhite });

      if (isWhite) { window.location.href = url; return; } // weiss=1 steckt schon in url

      // Gewähltes Gebinde als Variante in die URL setzen (Farbton steckt schon drin).
      fetchProductVariants(handle).then(function(variants){
        var finalUrl = url;
        if (variants.length && global.FTKATC && global.FTKATC.resolveVariant) {
          var rv = global.FTKATC.resolveVariant({ variants: variants, klasse: pcNum, currentO2: S.gebindeLabel });
          if (rv && rv.variantId) {
            finalUrl = /[?&]variant=\d+/.test(url)
              ? url.replace(/([?&]variant=)\d+/, "$1"+rv.variantId)
              : url + (url.indexOf("?")>-1?"&":"?") + "variant=" + rv.variantId;
          }
        }
        window.location.href = finalUrl;
      }).catch(function(){ window.location.href = url; });
    }

    // Volle Shopify-Variantenliste eines Produkts (gecacht) für resolveVariant.
    var _variantCache = {};
    function fetchProductVariants(handle) {
      if (!handle) return Promise.resolve([]);
      if (_variantCache[handle]) return Promise.resolve(_variantCache[handle]);
      return fetch("/products/"+handle+".js").then(function(r){ return r.json(); }).then(function(p){
        var vs = (p.variants||[]).map(function(v){
          return { id:v.id, option1:v.option1, option2:v.option2, option3:v.option3, price:v.price, available:v.available, title:v.title };
        });
        _variantCache[handle] = vs;
        return vs;
      }).catch(function(){ return []; });
    }

    // ── Initialer Fav-Badge ──
    updateFavBadge();

    return {
      destroy: function() {
        rootEl.removeEventListener("click", handleClick);
        rootEl.removeEventListener("input", handleInput);
        rootEl.removeEventListener("change", handleChange);
        rootEl.removeEventListener("pointerdown", handlePointerDown);
        document.removeEventListener("keydown", handleKeydown);
        if (_stickyResizeHandler) window.removeEventListener("resize", _stickyResizeHandler);
        if (_mobSearchStop) { try { _mobSearchStop(); } catch(e){} }
        rootEl.innerHTML="";
      },
      getState: function() { return S; }
    };
  }

  global.FTKV18 = { boot: boot };

})(window);
